// This file is auto-generated by scripts/content-indexing/generate-concept-index.js
// Do not edit manually - changes will be overwritten

export interface ConceptMetadata {
  difficulty: 'Advanced' | 'Beginner' | 'Intermediate';
  iconName: string;
  id: string;
  keywords: string[];
  name: string;
}

export interface ConceptsByLetter {
  [letter: string]: ConceptMetadata[];
}

/**
 * Auto-generated concept index containing 717 concepts
 * Generated on: 2025-12-12T15:35:52.981Z
 */
export const conceptsByLetter: ConceptsByLetter = {
  "#": [
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "30-60-90-triangles",
      "keywords": [
        "30-60-90 triangle",
        "right triangle",
        "geometry",
        "trigonometry",
        "Pythagorean theorem"
      ],
      "name": "30-60-90 Triangles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "45-45-90-triangles",
      "keywords": [
        "geometry",
        "triangle",
        "45-45-90",
        "isosceles",
        "right triangle"
      ],
      "name": "45-45-90 Triangles"
    }
  ],
  "A": [
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "aa-similarity",
      "keywords": [
        "geometry",
        "similarity",
        "congruent angles",
        "triangles",
        "AA"
      ],
      "name": "AA (Angle-Angle) Similarity"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "aas-postulate",
      "keywords": [
        "AAS",
        "Angle-Angle-Side",
        "postulate",
        "congruent triangles",
        "geometry"
      ],
      "name": "AAS (Angle-Angle-Side) Postulate"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "absolute-value",
      "keywords": [
        "absolute value",
        "number line",
        "distance from zero",
        "positive number",
        "negative number"
      ],
      "name": "Absolute Value"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "absolute-value-functions",
      "keywords": [
        "absolute value",
        "function",
        "algebra",
        "graphing",
        "mathematics"
      ],
      "name": "Absolute Value Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "absolute-value-inequalities",
      "keywords": [
        "absolute value",
        "inequalities",
        "algebra",
        "math",
        "middle school"
      ],
      "name": "Absolute Value Inequalities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "absolute-value-complex-number",
      "keywords": [
        "absolute value",
        "complex number",
        "math",
        "middle school",
        "interactive"
      ],
      "name": "Absolute Value of a Complex Number"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "accuracy-and-error",
      "keywords": [
        "accuracy",
        "error",
        "approximation",
        "measurement",
        "real-world problems"
      ],
      "name": "Accuracy and Error"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Variable",
      "id": "adding-and-subtracting-complex-numbers",
      "keywords": [
        "complex numbers",
        "adding",
        "subtracting",
        "math",
        "algebra"
      ],
      "name": "Adding and Subtracting Complex Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-decimals",
      "keywords": [
        "decimal",
        "addition",
        "subtraction",
        "mathematics",
        "numeracy"
      ],
      "name": "Adding and Subtracting Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-fractions",
      "keywords": [
        "fraction",
        "addition",
        "subtraction",
        "denominator",
        "numerator"
      ],
      "name": "Adding and Subtracting Fractions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-fractions-like-denominators",
      "keywords": [
        "fractions",
        "adding",
        "subtracting",
        "like denominators",
        "mathematics"
      ],
      "name": "Adding and Subtracting Fractions with Like Denominators"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-fractions-negatives",
      "keywords": [
        "add",
        "subtract",
        "fractions",
        "negatives",
        "math"
      ],
      "name": "Adding and Subtracting Fractions with Negatives"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-fractions-unlike-denominators",
      "keywords": [
        "adding fractions",
        "subtracting fractions",
        "fractions",
        "unlike denominators",
        "math"
      ],
      "name": "Adding and Subtracting Fractions with Unlike Denominators"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "adding-and-subtracting-matrices",
      "keywords": [
        "matrices",
        "adding matrices",
        "subtracting matrices",
        "pre-calculus",
        "mathematics"
      ],
      "name": "Adding and Subtracting Matrices"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "adding-subtracting-polynomials",
      "keywords": [
        "polynomials",
        "adding",
        "subtracting",
        "monomials",
        "binomials",
        "trinomials"
      ],
      "name": "Adding and Subtracting Polynomials"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "adding-and-subtracting-rational-expressions-with-like-denominators",
      "keywords": [
        "Rational expressions",
        "Like denominators",
        "Addition",
        "Subtraction",
        "Polynomials"
      ],
      "name": "Adding and Subtracting Rational Expressions with Like Denominators"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-rational-expressions-with-unlike-denominators",
      "keywords": [
        "Rational Expressions",
        "Unlike Denominators",
        "Adding",
        "Subtracting",
        "Fractions"
      ],
      "name": "Adding and Subtracting Rational Expressions with Unlike Denominators"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-vectors",
      "keywords": [
        "vectors",
        "math",
        "addition",
        "subtraction",
        "education"
      ],
      "name": "Adding and Subtracting Vectors"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "adding-and-subtracting-negatives",
      "keywords": [
        "addition",
        "subtraction",
        "negatives",
        "math",
        "middle school"
      ],
      "name": "Adding and Subtracting with Negatives"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "adding-fractions",
      "keywords": [
        "adding fractions",
        "like denominators",
        "unlike denominators",
        "equivalent fractions",
        "least common multiple"
      ],
      "name": "Adding Fractions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "adding-fractions-like-denominators",
      "keywords": [
        "Fractions",
        "Addition",
        "Math",
        "Middle School",
        "Homework Help"
      ],
      "name": "Adding Fractions with Like Denominators"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "adding-fractions-unlike-denominators",
      "keywords": [
        "fractions",
        "unlike denominators",
        "math",
        "middle school",
        "addition"
      ],
      "name": "Adding Fractions with Unlike Denominators"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "addition-rule-of-probability",
      "keywords": [
        "probability",
        "addition rule",
        "mathematics",
        "middle school",
        "Venn diagrams"
      ],
      "name": "Addition Rule in Probability"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "mixed-numbers-addition",
      "keywords": [
        "mixed numbers",
        "fractions",
        "addition",
        "math",
        "middle school"
      ],
      "name": "Addition: Mixed Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Sigma",
      "id": "addition-whole-numbers",
      "keywords": [
        "addition",
        "whole numbers",
        "math",
        "arithmetic",
        "sum"
      ],
      "name": "Addition: Whole Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "adjacent-angles",
      "keywords": [
        "Adjacent angles",
        "Geometry",
        "Angles",
        "Middle school Math",
        "Math"
      ],
      "name": "Adjacent Angles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "adjoint-of-a-matrix",
      "keywords": [
        "Adjoint",
        "Matrix",
        "Linear Algebra",
        "Determinants",
        "Cofactors"
      ],
      "name": "Adjoint of a Matrix"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "advanced-factoring",
      "keywords": [
        "Factoring",
        "Quadratic",
        "Trinomials",
        "Polynomials",
        "Roots"
      ],
      "name": "Advanced Factoring"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "alternate-exterior-angles",
      "keywords": [
        "alternate",
        "exterior",
        "angles",
        "geometry",
        "transversal"
      ],
      "name": "Alternate Exterior Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "alternate-exterior-angles-theorem",
      "keywords": [
        "alternate exterior angles",
        "geometry",
        "angles",
        "theorem",
        "middle school math"
      ],
      "name": "Alternate Exterior Angles Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "alternate-interior-angles",
      "keywords": [
        "alternate interior angles",
        "geometry",
        "angles",
        "parallel lines",
        "transversal"
      ],
      "name": "Alternate Interior Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "alternate-interior-angles-theorem",
      "keywords": [
        "alternate interior angles",
        "parallel lines",
        "transversal",
        "congruent angles",
        "geometry"
      ],
      "name": "Alternate Interior Angles Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "altitude-of-a-triangle",
      "keywords": [
        "altitude",
        "triangle",
        "geometry",
        "middle school",
        "math"
      ],
      "name": "Altitude of a Triangle"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "amplitude-and-period-of-sine-and-cosine-functions",
      "keywords": [
        "amplitude",
        "period",
        "sine function",
        "cosine function",
        "trigonometry"
      ],
      "name": "Amplitude and Period of Sine and Cosine Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "angle-addition-postulate",
      "keywords": [
        "math",
        "geometry",
        "angles",
        "postulate",
        "middle school"
      ],
      "name": "Angle Addition Postulate"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Triangle",
      "id": "angle-bisector",
      "keywords": [
        "geometry",
        "angle",
        "bisector",
        "congruent",
        "theorem"
      ],
      "name": "Angle Bisector"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "angle-of-intersecting-chords-theorem",
      "keywords": [
        "angle",
        "intersecting chords",
        "theorem",
        "geometry",
        "circle"
      ],
      "name": "Angle of Intersecting Chords Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "angle-of-intersecting-secants-theorem",
      "keywords": [
        "angle",
        "secants",
        "theorem",
        "geometry",
        "intercepts"
      ],
      "name": "Angle of Intersecting Secants Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "angle-of-rotation",
      "keywords": [
        "rotation",
        "angle",
        "geometry",
        "transformation",
        "degrees"
      ],
      "name": "Angle of Rotation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Sigma",
      "id": "angle-sum-theorem",
      "keywords": [
        "angle",
        "triangle",
        "sum",
        "theorem",
        "geometry"
      ],
      "name": "Angle Sum Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "angle-angle-similarity",
      "keywords": [
        "geometry",
        "triangles",
        "AA similarity",
        "congruence",
        "math"
      ],
      "name": "Angle-Angle Similarity"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "angles",
      "keywords": [
        "angles",
        "geometry",
        "degrees",
        "radians",
        "vertex"
      ],
      "name": "Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "angles-of-elevation-and-depression",
      "keywords": [
        "angles",
        "elevation",
        "depression",
        "geometry",
        "trigonometry"
      ],
      "name": "Angles of Elevation & Depression"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Circle",
      "id": "arcs",
      "keywords": [
        "arcs",
        "circle",
        "geometry",
        "math",
        "education"
      ],
      "name": "Arcs"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "area",
      "keywords": [
        "area",
        "geometry",
        "math",
        "education",
        "learning"
      ],
      "name": "Area"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "area-problem-solving",
      "keywords": [
        "area",
        "shapes",
        "problem solving",
        "math",
        "middle school"
      ],
      "name": "Area Problem Solving"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "areas-of-regular-polygons",
      "keywords": [
        "geometry",
        "mathematics",
        "polygons",
        "area",
        "apothem"
      ],
      "name": "Areas of Regular Polygons"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "arithmetic-sequences",
      "keywords": [
        "sequences",
        "arithmetic",
        "patterns",
        "numbers",
        "mathematics"
      ],
      "name": "Arithmetic Sequences"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Sigma",
      "id": "arithmetic-series",
      "keywords": [
        "arithmetic series",
        "series",
        "sequence",
        "sum",
        "arithmetic"
      ],
      "name": "Arithmetic Series"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "asa-postulate",
      "keywords": [
        "asa postulate",
        "geometry",
        "congruence",
        "triangles",
        "math"
      ],
      "name": "ASA (Angle-Side-Angle) Postulate"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "FileText",
      "id": "associative-properties-of-matrices",
      "keywords": [
        "Matrices",
        "Associative Property",
        "Matrix Addition",
        "Matrix Multiplication",
        "Math Concepts"
      ],
      "name": "Associative Properties of Matrices"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "asymptotes",
      "keywords": [
        "asymptotes",
        "math",
        "graph",
        "curve",
        "infinity"
      ],
      "name": "Asymptotes"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "augmented-matrix",
      "keywords": [
        "augmented matrices",
        "matrices",
        "linear equations",
        "mathematics",
        "algebra"
      ],
      "name": "Augmented Matrices"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "axiom",
      "keywords": [
        "axiom",
        "mathematics",
        "Euclid's Postulates",
        "geometry",
        "theorem"
      ],
      "name": "Axiom"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "axis-of-symmetry-of-a-parabola",
      "keywords": [
        "axis of symmetry",
        "parabola",
        "quadratic function",
        "vertex",
        "coordinates"
      ],
      "name": "Axis of Symmetry of a Parabola"
    }
  ],
  "B": [
    {
      "difficulty": "Beginner",
      "iconName": "BarChart",
      "id": "bar-graphs",
      "keywords": [
        "bar graphs",
        "graphing",
        "data visualization",
        "statistics",
        "math"
      ],
      "name": "Bar Graphs"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "basic-operations",
      "keywords": [
        "addition",
        "subtraction",
        "multiplication",
        "division",
        "exponents"
      ],
      "name": "Basic Operations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "basic-trigonometric-identities",
      "keywords": [
        "Trigonometry",
        "Math",
        "Identities",
        "Pythagorean Theorem",
        "High School"
      ],
      "name": "Basic Trigonometric Identities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "biconditional-statement",
      "keywords": [
        "biconditional statement",
        "math logic",
        "conditional statement",
        "converse",
        "math symbols"
      ],
      "name": "Biconditional Statement"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "binary-numbers",
      "keywords": [
        "binary",
        "base 2",
        "computer science",
        "numbers",
        "digit"
      ],
      "name": "Binary Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "binomial-probability",
      "keywords": [
        "probability",
        "binomial",
        "success",
        "failure",
        "trial"
      ],
      "name": "Binomial Probability"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "binomial-series",
      "keywords": [
        "binomial series",
        "Taylor series",
        "Maclaurin series",
        "series expansion",
        "convergence"
      ],
      "name": "Binomial Series"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "bisectors-in-a-triangle",
      "keywords": [
        "bisectors",
        "triangle",
        "geometry",
        "math",
        "circumcenter"
      ],
      "name": "Bisectors in a Triangle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "box-and-whisker-plots",
      "keywords": [
        "box-and-whisker plots",
        "statistics",
        "data",
        "mathematics",
        "middle school math"
      ],
      "name": "Box-and-Whisker Plots"
    }
  ],
  "C": [
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "capacity",
      "keywords": [
        "capacity",
        "volume",
        "metric units",
        "US customary units",
        "conversion"
      ],
      "name": "Capacity"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "center-and-variation-of-data",
      "keywords": [
        "central tendency",
        "variation of data",
        "mean",
        "median",
        "mode"
      ],
      "name": "Center and Variation of Data"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "center-of-rotation",
      "keywords": [
        "Center of Rotation",
        "Geometry",
        "Rotation",
        "Invariant point",
        "Angle of rotation"
      ],
      "name": "Center of Rotation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "central-angles",
      "keywords": [
        "central angles",
        "geometry",
        "circle",
        "angle",
        "math"
      ],
      "name": "Central Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "centroid",
      "keywords": [
        "centroid",
        "geometry",
        "median",
        "triangle",
        "middle"
      ],
      "name": "Centroid"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "choosing-appropriate-units-of-measure",
      "keywords": [
        "units of measure",
        "Imperial system",
        "Metric system",
        "appropriate unit",
        "measurement"
      ],
      "name": "Choosing Appropriate Units of Measure"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Circle",
      "id": "chord",
      "keywords": [
        "chords",
        "geometry",
        "circles",
        "math",
        "education"
      ],
      "name": "Chords"
    },
    {
      "difficulty": "Beginner",
      "iconName": "BarChart",
      "id": "circle-graphs",
      "keywords": [
        "Circle Graphs",
        "Pie Charts",
        "Data Visualization",
        "Graphs",
        "Surveys"
      ],
      "name": "Circle Graphs"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Circle",
      "id": "circle",
      "keywords": [
        "circles",
        "radius",
        "diameter",
        "circumference",
        "pi"
      ],
      "name": "Circles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "circles-inscribed-in-squares",
      "keywords": [
        "circle",
        "square",
        "inscribed",
        "geometry",
        "math"
      ],
      "name": "Circles Inscribed in Squares"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "area-of-a-circle",
      "keywords": [
        "Circles",
        "Area",
        "Math",
        "Middle School",
        "Education"
      ],
      "name": "Circles: Area"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "circumcenter-theorem",
      "keywords": [
        "geometry",
        "circumcenter",
        "theorem",
        "perpendicular bisectors",
        "equidistant"
      ],
      "name": "Circumcenter Theorem"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Circle",
      "id": "circumference",
      "keywords": [
        "circumference",
        "circle",
        "radius",
        "diameter",
        "pi"
      ],
      "name": "Circumference"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "coefficient",
      "keywords": [
        "coefficient",
        "polynomial",
        "variable",
        "algebra",
        "math"
      ],
      "name": "Coefficient"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "collinear-points",
      "keywords": [
        "collinear points",
        "geometry",
        "lines",
        "points",
        "coordinate geometry"
      ],
      "name": "Collinear Points"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "combinations",
      "keywords": [
        "combinations",
        "mathematics",
        "education",
        "middle school",
        "math"
      ],
      "name": "Combinations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "combined-variation",
      "keywords": [
        "combined variation",
        "direct variation",
        "inverse variation",
        "variables",
        "equations"
      ],
      "name": "Combined Variation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "combining-like-terms",
      "keywords": [
        "algebra",
        "like terms",
        "variables",
        "distributive property",
        "math"
      ],
      "name": "Combining (\"Gathering\") Like Terms"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "gathering-like-terms",
      "keywords": [
        "math",
        "combining like terms",
        "algebra",
        "middle school math",
        "math variables"
      ],
      "name": "Combining (\"Gathering\") Like Terms"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "combining-like-terms-with-exponents",
      "keywords": [
        "exponents",
        "like terms",
        "combining terms",
        "algebra",
        "math"
      ],
      "name": "Combining (\"Gathering\") Like Terms with Exponents"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "common-difference",
      "keywords": [
        "Arithmetic Sequence",
        "Common Difference",
        "Pattern",
        "Sequence",
        "Term"
      ],
      "name": "Common Difference"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "common-ratio",
      "keywords": [
        "common ratio",
        "geometric sequence",
        "mathematical sequence",
        "ratios",
        "mathematical patterns"
      ],
      "name": "Common Ratio"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "commutative-associative-distributive-laws",
      "keywords": [
        "Algebra",
        "Commutative Law",
        "Associative Law",
        "Distributive Law",
        "Math Properties"
      ],
      "name": "Commutative Associative Distributive Laws"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "comparing-and-ordering-integers",
      "keywords": [
        "integers",
        "ordering",
        "comparing",
        "number line",
        "negative"
      ],
      "name": "Comparing and Ordering Integers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "comparing-decimals",
      "keywords": [
        "Decimals",
        "Math",
        "Compare",
        "Fraction",
        "Number"
      ],
      "name": "Comparing Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "comparing-fractions",
      "keywords": [
        "fractions",
        "comparing",
        "mathematics",
        "middle school",
        "education"
      ],
      "name": "Comparing Fractions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "comparing-functions",
      "keywords": [
        "functions",
        "comparing",
        "linear",
        "quadratic",
        "graph"
      ],
      "name": "Comparing Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "comparing-linear-polynomial-and-exponential-growth",
      "keywords": [
        "Linear Growth",
        "Polynomial Growth",
        "Exponential Growth",
        "Algebra",
        "Functions"
      ],
      "name": "Comparing Linear, Polynomial, and Exponential Growth"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "comparing-quantities",
      "keywords": [
        "comparing quantities",
        "fractions",
        "decimals",
        "percentages",
        "math"
      ],
      "name": "Comparing Quantities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "compatible-matrices",
      "keywords": [
        "matrices",
        "compatible matrices",
        "matrix multiplication",
        "matrix dimensions",
        "math"
      ],
      "name": "Compatible Matrices"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "complement-of-an-event",
      "keywords": [
        "probability",
        "complement",
        "event",
        "sample space",
        "subset"
      ],
      "name": "Complement of an Event"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "complementary-angles",
      "keywords": [
        "complementary angles",
        "geometry",
        "angle relationships",
        "adjacent angles",
        "acute angles"
      ],
      "name": "Complementary Angles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "completing-the-square",
      "keywords": [
        "completing the square",
        "quadratic equation",
        "polynomials",
        "square roots",
        "math"
      ],
      "name": "Completing the Square"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "complex-numbers",
      "keywords": [
        "complex numbers",
        "imaginary numbers",
        "real numbers",
        "complex (Argand) plane",
        "absolute value"
      ],
      "name": "Complex Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "components-of-a-vector",
      "keywords": [
        "vector",
        "components",
        "trigonometry",
        "geometry",
        "math"
      ],
      "name": "Components of a Vector"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "composition-of-functions",
      "keywords": [
        "composition of functions",
        "functions",
        "math",
        "middle school",
        "education"
      ],
      "name": "Composition of Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "compound-events",
      "keywords": [
        "compound events",
        "probability",
        "outcomes",
        "simple events",
        "math"
      ],
      "name": "Compound Events"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "compound-inequalities",
      "keywords": [
        "compound inequalities",
        "math",
        "middle school",
        "inequalities",
        "algebra"
      ],
      "name": "Compound Inequalities"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "compound-interest",
      "keywords": [
        "compound interest",
        "interest rate",
        "investment",
        "math",
        "finance"
      ],
      "name": "Compound Interest"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "conditional-probability",
      "keywords": [
        "probability",
        "conditional probability",
        "statistics",
        "math",
        "middle school"
      ],
      "name": "Conditional Probability"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "conditional-statements",
      "keywords": [
        "conditional statements",
        "logic",
        "if-then statements",
        "hypothesis",
        "conclusion"
      ],
      "name": "Conditional Statements"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "cone",
      "keywords": [
        "cone",
        "geometry",
        "volume",
        "surface area",
        "pyramids"
      ],
      "name": "Cones"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "congruent-angles",
      "keywords": [
        "geometry",
        "angles",
        "congruent angles",
        "math"
      ],
      "name": "Congruent Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "congruent-figures",
      "keywords": [
        "congruent figures",
        "geometry",
        "congruence",
        "translations",
        "rotations"
      ],
      "name": "Congruent Figures"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "congruent-segments",
      "keywords": [
        "geometry",
        "congruent segments",
        "line segments",
        "congruence",
        "mathematics"
      ],
      "name": "Congruent Segments"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "congruent-tangents-and-circumscribed-polygons",
      "keywords": [
        "geometry",
        "circles",
        "tangents",
        "polygons",
        "congruence"
      ],
      "name": "Congruent Tangents and Circumscribed Polygons"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "congruent-triangles",
      "keywords": [
        "congruent triangles",
        "geometry",
        "triangles",
        "math",
        "education"
      ],
      "name": "Congruent Triangles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "congruent-triangles-on-the-coordinate-plane",
      "keywords": [
        "geometry",
        "congruent triangles",
        "coordinate plane",
        "SSS congruence",
        "distance formula"
      ],
      "name": "Congruent Triangles on the Coordinate Plane"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "conic-sections-and-standard-forms-of-equations",
      "keywords": [
        "conic sections",
        "standard forms",
        "equations",
        "geometry",
        "mathematics"
      ],
      "name": "Conic Sections and Standard Forms of Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "conjugates",
      "keywords": [
        "Conjugates",
        "complex numbers",
        "rationalize",
        "denominator",
        "imaginary numbers"
      ],
      "name": "Conjugates"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "conjunction",
      "keywords": [
        "conjunction",
        "logic",
        "mathematical logic",
        "compound statements",
        "truth value"
      ],
      "name": "Conjunction"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "consecutive-interior-angles-theorem",
      "keywords": [
        "geometry",
        "angles",
        "parallel lines",
        "transversal",
        "supplementary"
      ],
      "name": "Consecutive Interior Angles Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "consecutive-interior-angles",
      "keywords": [
        "Consecutive Interior Angles",
        "Angles",
        "Geometry",
        "Middle School",
        "Math"
      ],
      "name": "Consecutive Interior Angles Theorem"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "consistent-and-dependent-systems",
      "keywords": [
        "consistent systems",
        "dependent systems",
        "linear equations",
        "graphing",
        "systems of equations"
      ],
      "name": "Consistent and Dependent Systems"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "constant-function",
      "keywords": [
        "constant function",
        "function",
        "linear function",
        "domain",
        "range"
      ],
      "name": "Constant Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "constant-of-variation",
      "keywords": [
        "Constant of Variation",
        "Direct Variation",
        "Indirect Variation",
        "Proportions",
        "Ratios"
      ],
      "name": "Constant of Variation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "converse-of-isosceles-triangle-theorem",
      "keywords": [
        "isosceles triangle",
        "congruent angles",
        "congruent sides",
        "geometry",
        "theorem"
      ],
      "name": "Converse of Isosceles Triangle Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "converse-inverse-contrapositive",
      "keywords": [
        "conditional statements",
        "logic",
        "converse",
        "inverse",
        "contrapositive"
      ],
      "name": "Converse, Inverse, Contrapositive"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "convert-between-systems",
      "keywords": [
        "conversion",
        "measurement",
        "metric system",
        "customary units",
        "math"
      ],
      "name": "Convert between Systems"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "convert-units-of-area-and-volume",
      "keywords": [
        "Area",
        "Volume",
        "Conversion",
        "Units of Measure",
        "Mathematics"
      ],
      "name": "Convert Units of Area and Volume"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "converting-non-repeating-decimals-to-fractions",
      "keywords": [
        "decimals",
        "fractions",
        "non-repeating decimals",
        "math",
        "conversion"
      ],
      "name": "Converting Decimals to Fractions: Non-repeating"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "converting-repeating-decimals-to-fractions",
      "keywords": [
        "decimals",
        "fractions",
        "numerator",
        "denominator",
        "repeating decimals"
      ],
      "name": "Converting Decimals to Fractions: Repeating"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "converting-fractions-to-decimals",
      "keywords": [
        "fraction",
        "decimal",
        "conversion",
        "numeracy",
        "math"
      ],
      "name": "Converting Fractions to Decimals"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "converting-fractions-to-percent",
      "keywords": [
        "Fractions",
        "Percentages",
        "Math",
        "Conversions",
        "Middle School"
      ],
      "name": "Converting Fractions to Percent"
    },
    {
      "difficulty": "Advanced",
      "iconName": "CircleDot",
      "id": "coordinate-proofs",
      "keywords": [
        "coordinate proofs",
        "geometry",
        "cartesian plane",
        "midpoint formula",
        "distance formula"
      ],
      "name": "Coordinate Proofs"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "coplanar",
      "keywords": [
        "coplanar",
        "geometry",
        "planes",
        "points",
        "lines"
      ],
      "name": "Coplanar"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "correlation-and-causal-relation",
      "keywords": [
        "correlation",
        "causal relation",
        "cause and effect",
        "statistics",
        "math"
      ],
      "name": "Correlation and Causal Relation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "corresponding-angles",
      "keywords": [
        "geometry",
        "angles",
        "parallel lines",
        "transversal",
        "corresponding angles"
      ],
      "name": "Corresponding Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "corresponding-angles-postulate",
      "keywords": [
        "corresponding angles",
        "postulate",
        "geometry",
        "congruent angles",
        "transversal"
      ],
      "name": "Corresponding Angles Postulate"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Tangent",
      "id": "cosine",
      "keywords": [
        "trigonometry",
        "cosine",
        "mathematics",
        "ratios",
        "hypotenuse"
      ],
      "name": "Cosine"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Tangent",
      "id": "cosine-function",
      "keywords": [
        "Trigonometry",
        "Cosine",
        "Functions",
        "Math",
        "Middle School"
      ],
      "name": "Cosine Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "coterminal-angles",
      "keywords": [
        "coterminal angles",
        "angle measurement",
        "degrees",
        "radians",
        "geometry"
      ],
      "name": "Coterminal Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "counterexample",
      "keywords": [
        "counterexample",
        "mathematics",
        "proof",
        "statement",
        "geometry"
      ],
      "name": "Counterexample"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "cramers-rule",
      "keywords": [
        "cramer's rule",
        "linear equations",
        "determinant",
        "matrix",
        "math"
      ],
      "name": "Cramer's Rule"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "cross-products",
      "keywords": [
        "cross products",
        "vector mathematics",
        "physics",
        "engineering",
        "math"
      ],
      "name": "Cross Products"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cone",
      "id": "cross-sections",
      "keywords": [
        "cross sections",
        "geometry",
        "3D shapes",
        "2D shapes",
        "intersections"
      ],
      "name": "Cross Sections"
    },
    {
      "difficulty": "Beginner",
      "iconName": "SquareFunction",
      "id": "cubic-functions",
      "keywords": [
        "Cubic",
        "Functions",
        "Math",
        "Middle School",
        "Algebra"
      ],
      "name": "Cubic Functions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Cylinder",
      "id": "customary-units",
      "keywords": [
        "customary units",
        "measurement",
        "length",
        "weight",
        "volume"
      ],
      "name": "Customary Units"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "cylinder",
      "keywords": [
        "cylinder",
        "geometry",
        "3D shapes",
        "volume",
        "surface area"
      ],
      "name": "Cylinder"
    }
  ],
  "D": [
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "degree-measure-of-an-angle",
      "keywords": [
        "degree",
        "angle",
        "rotation",
        "circle",
        "geometry"
      ],
      "name": "Degree Measure of an Angle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "degree-of-a-monomial",
      "keywords": [
        "degree",
        "monomial",
        "exponents",
        "polynomials",
        "mathematics"
      ],
      "name": "Degree of a Monomial"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "degree-of-a-polynomial",
      "keywords": [
        "polynomial",
        "degree",
        "monomial",
        "exponents",
        "math"
      ],
      "name": "Degree of a Polynomial"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "degree-of-a-vertex",
      "keywords": [
        "graph theory",
        "degree",
        "vertex",
        "edges",
        "mathematics"
      ],
      "name": "Degree of a Vertex"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "degree-to-radian-measure",
      "keywords": [
        "degree",
        "radian",
        "angle",
        "conversion",
        "geometry"
      ],
      "name": "Degree to Radian Measure"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "denominator",
      "keywords": [
        "denominator",
        "fractions",
        "division",
        "numerator",
        "divisor"
      ],
      "name": "Denominator"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "dependent-events",
      "keywords": [
        "<a href=\"probability\">probability</a>",
        "dependent events",
        "conditional probability",
        "marbles",
        "events"
      ],
      "name": "Dependent Events"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "descartes-rule-of-signs",
      "keywords": [
        "<a href=\"polynomial-function\">polynomials</a>",
        "roots",
        "sign changes",
        "Descartes",
        "mathematics"
      ],
      "name": "Descartes Rule of Signs"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "describing-the-graph-of-a-function",
      "keywords": [
        "functions",
        "graphs",
        "increasing",
        "decreasing",
        "maxima and minima"
      ],
      "name": "Describing the Graph of a Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "determinants",
      "keywords": [
        "matrix",
        "determinant",
        "linear equations",
        "2x2 matrix",
        "solutions"
      ],
      "name": "Determinant of a Matrix"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "developing-a-probability-distribution-from-empirical-data",
      "keywords": [
        "probability",
        "empirical data",
        "frequency distribution",
        "statistical analysis",
        "expected value"
      ],
      "name": "Developing a Probability Distribution from Empirical Data"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "diagonals-of-parallelograms",
      "keywords": [
        "parallelogram",
        "diagonal",
        "geometry",
        "bisect",
        "quadrilateral"
      ],
      "name": "Diagonals of Parallelograms"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Circle",
      "id": "diameter",
      "keywords": [
        "geometry",
        "circle",
        "diameter",
        "radius",
        "circumference"
      ],
      "name": "Diameter"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "difference-of-squares",
      "keywords": [
        "difference of squares",
        "algebra",
        "factoring",
        "polynomials",
        "expansion"
      ],
      "name": "Difference of Squares"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "different-bases",
      "keywords": [
        "base conversion",
        "number systems",
        "base 3",
        "mathematics",
        "place value"
      ],
      "name": "Different Bases"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "dilation",
      "keywords": [
        "dilation",
        "scale factor",
        "geometry",
        "transformation",
        "enlargement"
      ],
      "name": "Dilation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "matrix-dimensions",
      "keywords": [
        "matrix",
        "dimensions",
        "rows",
        "columns",
        "square matrix"
      ],
      "name": "Dimensions of a Matrix"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "direct-inverse-variation",
      "keywords": [
        "Direct Variation",
        "Inverse Variation",
        "Mathematics",
        "Equations",
        "Variables"
      ],
      "name": "Direct & Inverse Variation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "direct-variation",
      "keywords": [
        "direct variation",
        "proportionality",
        "constant of variation",
        "linear relationship",
        "math equations"
      ],
      "name": "Direct Variation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "directrix",
      "keywords": [
        "directrix",
        "parabola",
        "focus",
        "vertex",
        "axis of symmetry"
      ],
      "name": "Directrix"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "disjunction",
      "keywords": [
        "disjunction",
        "logic",
        "or",
        "compound statements",
        "truth table"
      ],
      "name": "Disjunction"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "distance-between-parallel-lines",
      "keywords": [
        "parallel lines",
        "distance formula",
        "math",
        "geometry",
        "perpendicular"
      ],
      "name": "Distance Between Parallel Lines"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "distributive-property-of-matrices",
      "keywords": [
        "matrices",
        "distributive property",
        "matrix multiplication",
        "linear algebra",
        "mathematics"
      ],
      "name": "Distributive Property of Matrices"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "dividing-by-a-fraction",
      "keywords": [
        "dividing fractions",
        "reciprocals",
        "simplifying fractions",
        "fraction division",
        "math tricks"
      ],
      "name": "Dividing by a Fraction"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "dividing-complex-numbers",
      "keywords": [
        "complex numbers",
        "division",
        "conjugate",
        "imaginary numbers",
        "FOIL method"
      ],
      "name": "Dividing Complex Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "dividing-decimals",
      "keywords": [
        "dividing",
        "decimals",
        "math",
        "fractions",
        "calculations"
      ],
      "name": "Dividing Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "dividing-fractions",
      "keywords": [
        "dividing fractions",
        "reciprocal",
        "multiplicative inverse",
        "mixed numbers",
        "improper fractions"
      ],
      "name": "Dividing Fractions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "dividing-polynomials",
      "keywords": [
        "polynomials",
        "division",
        "algebra",
        "long division",
        "common factors"
      ],
      "name": "Dividing Polynomials"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "dividing-rational-expressions",
      "keywords": [
        "dividing",
        "rational",
        "expressions",
        "fractions",
        "algebra"
      ],
      "name": "Dividing Rational Expressions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "divisibility-tests",
      "keywords": [
        "divisibility",
        "math",
        "integers",
        "factors",
        "prime"
      ],
      "name": "Divisibility Tests"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "mixed-numbers-division",
      "keywords": [
        "mixed numbers",
        "division",
        "improper fractions",
        "reciprocals",
        "fractions"
      ],
      "name": "Division: Mixed Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "division-whole-numbers",
      "keywords": [
        "division",
        "whole numbers",
        "quotient",
        "divisor",
        "remainder"
      ],
      "name": "Division: Whole Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "domain-and-range",
      "keywords": [
        "domain",
        "range",
        "function",
        "set",
        "relation"
      ],
      "name": "Domain and Range"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "domain-and-range-of-exponential-and-logarithmic-functions",
      "keywords": [
        "domain",
        "range",
        "exponential",
        "logarithmic",
        "functions"
      ],
      "name": "Domain and Range of Exponential and Logarithmic Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "domain-and-range-of-rational-functions",
      "keywords": [
        "rational functions",
        "domain",
        "range",
        "math",
        "functions"
      ],
      "name": "Domain and Range of Rational Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "domains",
      "keywords": [
        "domains",
        "functions",
        "real numbers",
        "fractions",
        "radicals"
      ],
      "name": "Domains"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "double-angle-and-half-angle-identities",
      "keywords": [
        "trigonometry",
        "double angle",
        "half angle",
        "identities",
        "math"
      ],
      "name": "Double-Angle and Half-Angle Identities"
    }
  ],
  "E": [
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "e",
      "keywords": [
        "e",
        "irrational numbers",
        "calculus",
        "exponential functions",
        "natural exponential"
      ],
      "name": "e (the Number)"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "eccentricity",
      "keywords": [
        "eccentricity",
        "conic sections",
        "focus",
        "directrix",
        "geometry"
      ],
      "name": "Eccentricity"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "ellipse",
      "keywords": [
        "ellipse",
        "foci",
        "major axis",
        "minor axis",
        "quadratic equation"
      ],
      "name": "Ellipses"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "end-behavior-of-a-function",
      "keywords": [
        "end behavior",
        "polynomial function",
        "leading coefficient",
        "degree",
        "graph behavior"
      ],
      "name": "End Behavior of a Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "endvertex",
      "keywords": [
        "endvertex",
        "graph theory",
        "nodes",
        "leaf",
        "pendant vertex"
      ],
      "name": "End vertex"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Circle",
      "id": "equation-of-a-circle",
      "keywords": [
        "circle",
        "geometry",
        "radius",
        "diameter",
        "equation"
      ],
      "name": "Equation of a Circle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "equivalent-expressions",
      "keywords": [
        "equivalent",
        "expressions",
        "variables",
        "mathematics",
        "simplification"
      ],
      "name": "Equivalent Expressions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "equivalent-fractions",
      "keywords": [
        "fractions",
        "math",
        "equivalent",
        "numerator",
        "denominator"
      ],
      "name": "Equivalent Fractions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "PieChart",
      "id": "equivalent-ratios",
      "keywords": [
        "equivalent ratios",
        "proportionality",
        "ratios",
        "simplifying ratios",
        "cross products"
      ],
      "name": "Equivalent Ratios"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "evaluating-expressions",
      "keywords": [
        "algebra",
        "expressions",
        "variables",
        "arithmetic",
        "substitution"
      ],
      "name": "Evaluating Expressions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "even-odd-functions",
      "keywords": [
        "even functions",
        "odd functions",
        "symmetry",
        "graphing",
        "algebra"
      ],
      "name": "Even/Odd Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "expected-value",
      "keywords": [
        "expected value",
        "probability",
        "random variable",
        "weighted average",
        "mean"
      ],
      "name": "Expected Value"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "experimental-probability",
      "keywords": [
        "experimental probability",
        "theoretical probability",
        "probability",
        "math",
        "experiments"
      ],
      "name": "Experimental Probability"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "exponent-tables-and-patterns",
      "keywords": [
        "exponents",
        "patterns",
        "powers",
        "mathematics",
        "tables"
      ],
      "name": "Exponent Tables and Patterns"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "exponential-decay",
      "keywords": [
        "exponential decay",
        "half-life",
        "nuclear physics",
        "depreciation",
        "radioactive decay"
      ],
      "name": "Exponential Decay"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "exponential-functions",
      "keywords": [
        "exponential",
        "functions",
        "math",
        "growth",
        "decay"
      ],
      "name": "Exponential Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "exponential-growth",
      "keywords": [
        "exponential",
        "growth",
        "mathematics",
        "population",
        "investment"
      ],
      "name": "Exponential Growth"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "exponential-regression",
      "keywords": [
        "exponential",
        "regression",
        "growth",
        "decay",
        "modeling"
      ],
      "name": "Exponential Regression"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "exponential-to-logarithmic-form",
      "keywords": [
        "exponential",
        "logarithmic",
        "math",
        "functions",
        "form"
      ],
      "name": "Exponential to Logarithmic Form"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "exponents",
      "keywords": [
        "exponents",
        "powers",
        "math",
        "multiplication",
        "math operations"
      ],
      "name": "Exponents"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "exterior-angle-inequality",
      "keywords": [
        "exterior angle",
        "triangle",
        "inequality",
        "geometry",
        "theorem"
      ],
      "name": "Exterior Angle Inequality"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "exterior-angle-theorem",
      "keywords": [
        "exterior angle",
        "triangle",
        "geometry",
        "angle theorem",
        "math theorem"
      ],
      "name": "Exterior Angle Theorem"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "extraneous-solutions",
      "keywords": [
        "extraneous",
        "solutions",
        "equations",
        "domain",
        "roots"
      ],
      "name": "Extraneous Solutions"
    }
  ],
  "F": [
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "factorials",
      "keywords": [
        "factorials",
        "permutations",
        "combinations",
        "mathematics",
        "integers"
      ],
      "name": "Factorials"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "factoring",
      "keywords": [
        "factoring",
        "algebra",
        "polynomials",
        "distributive property",
        "FOIL method"
      ],
      "name": "Factoring"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Pi",
      "id": "factoring-by-grouping",
      "keywords": [
        "factoring",
        "grouping",
        "polynomials",
        "algebra",
        "distributive property"
      ],
      "name": "Factoring by Grouping"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "factoring-monomials",
      "keywords": [
        "factoring",
        "monomials",
        "prime factors",
        "mathematics",
        "algebra"
      ],
      "name": "Factoring Monomials"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "factoring-a-not-equal-to-one",
      "keywords": [
        "factoring",
        "polynomials",
        "trinomial",
        "quadratic",
        "algebra"
      ],
      "name": "Factoring: a ≠ 1"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "factoring-b-and-c-positive",
      "keywords": [
        "factoring",
        "polynomials",
        "trinomials",
        "math",
        "middle school"
      ],
      "name": "Factoring: b & c Positive"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "factoring-b-negative",
      "keywords": [
        "factoring",
        "polynomials",
        "trinomial",
        "negative b",
        "algebra"
      ],
      "name": "Factoring: b Negative"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "factoring-c-negative",
      "keywords": [
        "factoring",
        "polynomials",
        "negative c",
        "trinomial",
        "math"
      ],
      "name": "Factoring: c Negative"
    },
    {
      "difficulty": "Beginner",
      "iconName": "SquareFunction",
      "id": "factors",
      "keywords": [
        "factors",
        "division",
        "whole numbers",
        "common factors",
        "polynomials"
      ],
      "name": "Factors"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "falling-object-model",
      "keywords": [
        "falling",
        "object",
        "gravity",
        "velocity",
        "height"
      ],
      "name": "Falling Object Model"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "fibonacci-numbers",
      "keywords": [
        "Fibonacci",
        "sequence",
        "Leonardo Fibonacci",
        "Golden Ratio",
        "mathematics"
      ],
      "name": "Fibonacci Numbers (Sequence)"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Circle",
      "id": "finding-arc-lengths",
      "keywords": [
        "arc length",
        "circle",
        "geometry",
        "central angle",
        "circumference"
      ],
      "name": "Finding Arc Lengths"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "finding-the-area-of-a-triangle-using-sine",
      "keywords": [
        "area",
        "triangle",
        "sine",
        "geometry",
        "trigonometry"
      ],
      "name": "Finding the Area of a Triangle using Sine"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "finding-the-equation-of-a-line-from-its-graph",
      "keywords": [
        "equation of a line",
        "graph",
        "slope-intercept form",
        "y-intercept",
        "slope"
      ],
      "name": "Finding the Equation of a Line"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "finding-the-equation-of-a-parabola-given-focus-and-directrix",
      "keywords": [
        "parabola",
        "focus",
        "directrix",
        "equation",
        "geometry"
      ],
      "name": "Finding the Equation of a Parabola Given Focus and Directrix"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "finite-differences",
      "keywords": [
        "finite differences",
        "sequences",
        "mathematics",
        "education",
        "number sequences"
      ],
      "name": "Finite Differences"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "fitting-equations-to-data",
      "keywords": [
        "equations",
        "data fitting",
        "linear models",
        "quadratic functions",
        "exponential functions"
      ],
      "name": "Fitting Equations to Data"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "fitting-linear-equations-to-data",
      "keywords": [
        "linear equations",
        "data fitting",
        "<a href=\"scatter-plots\">scatter plots</a>",
        "line of best fit",
        "<a href=\"ordered-pair\">ordered pairs</a>"
      ],
      "name": "Fitting Linear Equations to Data"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Circle",
      "id": "focus",
      "keywords": [
        "focus",
        "conic sections",
        "circle",
        "parabola",
        "ellipse"
      ],
      "name": "Focus"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "focus-of-a-parabola",
      "keywords": [
        "parabola",
        "focus",
        "directrix",
        "vertex",
        "axis of symmetry"
      ],
      "name": "Focus of a Parabola"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "formulas",
      "keywords": [
        "formulas",
        "geometry",
        "algebra",
        "mathematics",
        "equations"
      ],
      "name": "Formulas"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "fraction-operations",
      "keywords": [
        "fractions",
        "addition",
        "subtraction",
        "multiplication",
        "division"
      ],
      "name": "Fraction Operations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "fractions",
      "keywords": [
        "fractions",
        "math",
        "numerator",
        "denominator",
        "division"
      ],
      "name": "Fractions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "lowest-terms",
      "keywords": [
        "fractions",
        "lowest terms",
        "simplest form",
        "greatest common factor",
        "math"
      ],
      "name": "Fractions in Lowest Terms"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "simplest-form",
      "keywords": [
        "fractions",
        "simplest form",
        "numerator",
        "denominator",
        "greatest common factor"
      ],
      "name": "Fractions in Simplest Form"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "frequency-distributions",
      "keywords": [
        "frequency",
        "distribution",
        "data",
        "math",
        "statistics"
      ],
      "name": "Frequency Distributions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "functions",
      "keywords": [
        "functions",
        "algebra",
        "trigonometry",
        "calculus",
        "applications"
      ],
      "name": "Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "functions-describing-behavior",
      "keywords": [
        "functions",
        "T-table",
        "linear",
        "nonlinear",
        "pattern recognition"
      ],
      "name": "Functions: Describing Behavior"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "functions-graphs-and-intersections",
      "keywords": [
        "functions",
        "graphs",
        "intersections",
        "algebra",
        "math"
      ],
      "name": "Functions: Graphs and Intersections"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "fundamental-counting-principle",
      "keywords": [
        "counting",
        "principle",
        "combinations",
        "probability",
        "math"
      ],
      "name": "Fundamental Counting Principle"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "fundamental-theorem-of-algebra",
      "keywords": [
        "algebra",
        "polynomials",
        "complex roots",
        "theorem",
        "math"
      ],
      "name": "Fundamental Theorem of Algebra"
    }
  ],
  "G": [
    {
      "difficulty": "Advanced",
      "iconName": "PieChart",
      "id": "geometric-mean",
      "keywords": [
        "geometric mean",
        "average",
        "central tendency",
        "math",
        "proportion"
      ],
      "name": "Geometric Mean"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "geometric-probability",
      "keywords": [
        "geometric probability",
        "ratios",
        "line segments",
        "geometry",
        "probability"
      ],
      "name": "Geometric Probability"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "geometric-sequences",
      "keywords": [
        "geometric sequences",
        "common ratio",
        "initial term",
        "exponents",
        "mathematical patterns"
      ],
      "name": "Geometric Sequences"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "geometric-series",
      "keywords": [
        "geometric sequences",
        "series",
        "sigma notation",
        "finite series",
        "infinite series"
      ],
      "name": "Geometric Series"
    },
    {
      "difficulty": "Advanced",
      "iconName": "PieChart",
      "id": "golden-ratio",
      "keywords": [
        "golden ratio",
        "golden mean",
        "golden proportion",
        "phi",
        "1.618033"
      ],
      "name": "Golden Ratio"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "golden-rectangle",
      "keywords": [
        "golden rectangle",
        "geometry",
        "ratios",
        "art",
        "architecture"
      ],
      "name": "Golden Rectangle"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "graph-theory",
      "keywords": [
        "graph theory",
        "vertices",
        "edges",
        "networks",
        "mathematics"
      ],
      "name": "Graph Theory"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "graphing-cosine-function",
      "keywords": [
        "cosine",
        "graphing",
        "trigonometry",
        "functions",
        "math"
      ],
      "name": "Graphing Cosine Function"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "graphing-exponential-and-logarithmic-functions",
      "keywords": [
        "exponential",
        "logarithmic",
        "graphing",
        "functions",
        "math"
      ],
      "name": "Graphing Exponential and Logarithmic Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "graphing-exponential-functions",
      "keywords": [
        "exponential",
        "graphing",
        "functions",
        "asymptote",
        "transformations"
      ],
      "name": "Graphing Exponential Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "graphing-inequalities-in-one-variable",
      "keywords": [
        "inequalities",
        "graphing",
        "number line",
        "math",
        "education"
      ],
      "name": "Graphing Inequalities in One Variable"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "graphing-linear-equations",
      "keywords": [
        "linear equations",
        "graphing",
        "slope",
        "intercepts",
        "coordinates"
      ],
      "name": "Graphing Linear Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "graphing-linear-inequalities-in-two-variables",
      "keywords": [
        "linear inequalities",
        "graphing",
        "two variables",
        "algebra",
        "math"
      ],
      "name": "Graphing Linear Inequalities in Two Variables"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "graphing-logarithmic-functions",
      "keywords": [
        "logarithmic functions",
        "graphing",
        "inverse functions",
        "exponential functions",
        "math concepts"
      ],
      "name": "Graphing Logarithmic Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "graphing-polygons",
      "keywords": [
        "graphing",
        "polygons",
        "coordinates",
        "vertices",
        "geometry"
      ],
      "name": "Graphing Polygons"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "graphing-functions-of-the-form-x-n",
      "keywords": [
        "graphing",
        "polynomial",
        "functions",
        "equations",
        "degree"
      ],
      "name": "Graphing Polynomial Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "graphing-polynomial-functions",
      "keywords": [
        "polynomial",
        "graphing",
        "functions",
        "degrees",
        "equations"
      ],
      "name": "Graphing Polynomial Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "graphing-quadratic-equations",
      "keywords": [
        "quadratic equations",
        "graphing",
        "parabolas",
        "vertex form",
        "algebra"
      ],
      "name": "Graphing Quadratic Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "graphing-quadratic-equations-using-factoring",
      "keywords": [
        "quadratic equations",
        "factoring",
        "graphing",
        "parabolas",
        "polynomials"
      ],
      "name": "Graphing Quadratic Equations using Factoring"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "graphing-quadratic-equations-using-the-axis-of-symmetry",
      "keywords": [
        "quadratic equations",
        "axis of symmetry",
        "graphing",
        "parabolas",
        "vertex"
      ],
      "name": "Graphing Quadratic Equations using the Axis of Symmetry"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "graphing-quadratic-equations-using-transformations",
      "keywords": [
        "quadratic equations",
        "transformations",
        "graphing",
        "parabolas",
        "math"
      ],
      "name": "Graphing Quadratic Equations using Transformations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "graphing-quadratic-inequalities",
      "keywords": [
        "quadratic",
        "inequalities",
        "graphing",
        "parabola",
        "algebra"
      ],
      "name": "Graphing Quadratic Inequalities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "graphing-rational-functions",
      "keywords": [
        "rational functions",
        "asymptotes",
        "intercepts",
        "graphing",
        "functions"
      ],
      "name": "Graphing Rational Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "graphing-sine-function",
      "keywords": [
        "sine",
        "graphing",
        "trigonometry",
        "functions",
        "math"
      ],
      "name": "Graphing Sine Function"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "graphing-square-root-functions",
      "keywords": [
        "graphing",
        "square root",
        "functions",
        "algebra",
        "mathematics"
      ],
      "name": "Graphing Square Root Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "graphing-systems-of-linear-inequalities",
      "keywords": [
        "linear inequalities",
        "graphing",
        "systems",
        "intersection",
        "math"
      ],
      "name": "Graphing Systems of Linear Inequalities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "graphing-tangent-function",
      "keywords": [
        "tangent",
        "graphing",
        "trigonometry",
        "functions",
        "math"
      ],
      "name": "Graphing Tangent Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "graphing-scale-and-origin",
      "keywords": [
        "graphing",
        "scale",
        "origin",
        "coordinate plane",
        "axes"
      ],
      "name": "Graphing: Scale and Origin"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "greatest-common-factor-of-monomials",
      "keywords": [
        "GCF",
        "monomials",
        "prime factorization",
        "common factors",
        "math lessons"
      ],
      "name": "Greatest Common Factor of Monomials"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "greatest-common-factors",
      "keywords": [
        "greatest common factors",
        "GCF",
        "prime factorization",
        "math",
        "factors"
      ],
      "name": "Greatest Common Factors"
    }
  ],
  "H": [
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "hexadecimal-numbers",
      "keywords": [
        "hexadecimal",
        "base 16",
        "number systems",
        "binary",
        "computing"
      ],
      "name": "Hexadecimal Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "histograms",
      "keywords": [
        "histograms",
        "data visualization",
        "frequency distribution",
        "bar graph",
        "intervals"
      ],
      "name": "Histograms"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "horizontal-vertical-lines",
      "keywords": [
        "horizontal lines",
        "vertical lines",
        "graphing",
        "equations",
        "coordinate plane"
      ],
      "name": "Horizontal and Vertical Lines"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "hyperbolas",
      "keywords": [
        "hyperbolas",
        "conic sections",
        "asymptotes",
        "graphing",
        "math"
      ],
      "name": "Hyperbolas"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Triangle",
      "id": "hypotenuse",
      "keywords": [
        "hypotenuse",
        "right triangle",
        "Pythagorean theorem",
        "geometry",
        "triangles"
      ],
      "name": "Hypotenuse"
    }
  ],
  "I": [
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "imaginary-unit",
      "keywords": [
        "imaginary unit",
        "complex numbers",
        "powers of i",
        "quadratic equations",
        "square roots"
      ],
      "name": "i(imaginary unit)"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "identity-matrix",
      "keywords": [
        "identity matrix",
        "matrix multiplication",
        "square matrix",
        "compatible matrices",
        "mathematical identity"
      ],
      "name": "Identity Matrix"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "improper-fractions",
      "keywords": [
        "fractions",
        "improper fractions",
        "mixed numbers",
        "conversion",
        "math problems"
      ],
      "name": "Improper Fractions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "independent-events",
      "keywords": [
        "probability",
        "independent events",
        "sample space",
        "event",
        "experiment"
      ],
      "name": "Independent Events"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "independent-dependent-events",
      "keywords": [
        "probability",
        "independent events",
        "dependent events",
        "mathematics",
        "middle school"
      ],
      "name": "Independent/Dependent Events"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "indirect-proof",
      "keywords": [
        "indirect proof",
        "proof by contradiction",
        "logical reasoning",
        "mathematics",
        "theorems"
      ],
      "name": "Indirect Proof"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "inductive-reasoning",
      "keywords": [
        "inductive reasoning",
        "patterns",
        "conjecture",
        "mathematical sequences",
        "problem solving"
      ],
      "name": "Inductive Reasoning"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "inequalities",
      "keywords": [
        "inequalities",
        "math",
        "expressions",
        "graphing",
        "solving"
      ],
      "name": "Inequalities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "infinite-geometric-series",
      "keywords": [
        "infinite series",
        "geometric series",
        "common ratio",
        "convergent series",
        "mathematical sum"
      ],
      "name": "Infinite Geometric Series"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "infinity",
      "keywords": [
        "infinity",
        "endless",
        "calculus",
        "mathematics",
        "limits"
      ],
      "name": "Infinity"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "input-output-tables",
      "keywords": [
        "input-output",
        "functions",
        "graphing",
        "ordered pairs",
        "math tables"
      ],
      "name": "Input-Output Tables"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Circle",
      "id": "inscribed-angles",
      "keywords": [
        "inscribed angles",
        "geometry",
        "circles",
        "chords",
        "intercepted arcs"
      ],
      "name": "Inscribed Angles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Circle",
      "id": "inscribing-a-quadrilateral",
      "keywords": [
        "cyclic quadrilateral",
        "inscribed quadrilateral",
        "geometry",
        "circle",
        "supplementary angles"
      ],
      "name": "Inscribing a Quadrilateral"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "integers",
      "keywords": [
        "integers",
        "whole numbers",
        "negative numbers",
        "number line",
        "math concepts"
      ],
      "name": "Integers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "interpreting-data",
      "keywords": [
        "data interpretation",
        "bar graphs",
        "line graphs",
        "circle graphs",
        "visual data"
      ],
      "name": "Interpreting Data"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "interquartile",
      "keywords": [
        "interquartile range",
        "semi-interquartile range",
        "midquartile range",
        "quartiles",
        "median"
      ],
      "name": "Interquartile, Semi-Interquartile and Midquartile Ranges"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Circle",
      "id": "intersecting-chords",
      "keywords": [
        "intersecting chords",
        "circle geometry",
        "angle measure",
        "chords",
        "arcs"
      ],
      "name": "Intersecting Chords (Finding Angle Measure)"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Circle",
      "id": "intersecting-chords-theorem",
      "keywords": [
        "intersecting chords",
        "circle geometry",
        "chord segments",
        "geometry",
        "theorem"
      ],
      "name": "Intersecting Chords Theorem"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "intersecting-secant-tangent-theorem",
      "keywords": [
        "geometry",
        "<a href=\"circle\">circle</a>",
        "tangent",
        "secant",
        "theorem"
      ],
      "name": "Intersecting Secant-Tangent Theorem"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Circle",
      "id": "intersecting-secants-theorem",
      "keywords": [
        "secants",
        "circle",
        "geometry",
        "theorem",
        "math"
      ],
      "name": "Intersecting Secants Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "interval-notation",
      "keywords": [
        "interval notation",
        "real number line",
        "closed interval",
        "open interval",
        "set union"
      ],
      "name": "Interval Notation"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "inverse-functions",
      "keywords": [
        "inverse functions",
        "one-to-one",
        "pre-calculus",
        "calculus",
        "mathematical inverses"
      ],
      "name": "Inverse Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "inverse-matrices",
      "keywords": [
        "matrix",
        "inverse",
        "linear algebra",
        "identity matrix",
        "matrix multiplication"
      ],
      "name": "Inverse of a Matrix"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "inverse-operations",
      "keywords": [
        "inverse",
        "operations",
        "addition",
        "subtraction",
        "math"
      ],
      "name": "Inverse Operations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "inverse-trigonometric-functions",
      "keywords": [
        "inverse trigonometric functions",
        "angles",
        "right triangles",
        "sine",
        "cosine"
      ],
      "name": "Inverse Trigonometric Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "PieChart",
      "id": "inverse-variation",
      "keywords": [
        "inverse variation",
        "proportional relationships",
        "math equations",
        "variables",
        "product rule"
      ],
      "name": "Inverse Variation"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "irrationals",
      "keywords": [
        "irrational",
        "numbers",
        "math",
        "real",
        "non-repeating"
      ],
      "name": "Irrational Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "irreducible-polynomials",
      "keywords": [
        "polynomials",
        "irreducible",
        "prime",
        "factoring",
        "degree"
      ],
      "name": "Irreducible (Prime) Polynomials"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "isosceles-triangle-theorem",
      "keywords": [
        "isosceles triangle",
        "geometry",
        "congruent angles",
        "SSS postulate",
        "triangle properties"
      ],
      "name": "Isosceles Triangle Theorem"
    }
  ],
  "J": [
    {
      "difficulty": "Advanced",
      "iconName": "PieChart",
      "id": "joint-variation",
      "keywords": [
        "joint variation",
        "direct variation",
        "proportional",
        "constant of variation",
        "math help"
      ],
      "name": "Joint Variation"
    }
  ],
  "K": [
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "kite",
      "keywords": [
        "geometry",
        "quadrilateral",
        "kite",
        "diagonals",
        "congruent"
      ],
      "name": "Kite"
    }
  ],
  "L": [
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "latus-rectum",
      "keywords": [
        "latus rectum",
        "conic sections",
        "geometry",
        "parabola",
        "ellipse"
      ],
      "name": "Latus Rectum"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "law-of-cosines",
      "keywords": [
        "law of cosines",
        "trigonometry",
        "geometry",
        "triangles",
        "SAS"
      ],
      "name": "Law of Cosines"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "law-of-detachment",
      "keywords": [
        "Law of Detachment",
        "Symbolic Logic",
        "Conditional Statements",
        "Logical Reasoning",
        "Mathematical Logic"
      ],
      "name": "Law of Detachment"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "law-of-sines",
      "keywords": [
        "Law of Sines",
        "Sine Rule",
        "Trigonometry",
        "Triangles",
        "Math"
      ],
      "name": "Law of Sines"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "law-of-syllogism",
      "keywords": [
        "syllogism",
        "logic",
        "conditional",
        "deductive",
        "reasoning"
      ],
      "name": "Law of Syllogism"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "leading-coefficient-test",
      "keywords": [
        "leading coefficient",
        "polynomial",
        "end behavior",
        "degree",
        "graph"
      ],
      "name": "Leading Coefficient Test"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "least-common-denominators",
      "keywords": [
        "least common denominators",
        "fractions",
        "LCM",
        "GCF",
        "math help"
      ],
      "name": "Least Common Denominators"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "least-common-multiples",
      "keywords": [
        "LCM",
        "Least Common Multiple",
        "Multiples",
        "Math",
        "Middle School Math"
      ],
      "name": "Least Common Multiples (LCMs)"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "length",
      "keywords": [
        "length",
        "metric system",
        "customary units",
        "measurement",
        "math"
      ],
      "name": "Length"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "line-graphs",
      "keywords": [
        "line graphs",
        "data visualization",
        "plotting",
        "graph interpretation",
        "time series"
      ],
      "name": "Line Graphs"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "line-of-best-fit-eyeball-method",
      "keywords": [
        "line of best fit",
        "eyeball method",
        "scatter plot",
        "correlation",
        "statistics"
      ],
      "name": "Line of Best Fit (Eyeball Method)"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "line-of-best-fit",
      "keywords": [
        "line of best fit",
        "least square method",
        "scatter plot",
        "linear regression",
        "data analysis"
      ],
      "name": "Line of Best Fit (Least Square Method)"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "line-plots",
      "keywords": [
        "line plots",
        "dot plots",
        "data visualization",
        "graphs",
        "statistics"
      ],
      "name": "Line Plots"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "line-symmetry",
      "keywords": [
        "symmetry",
        "line symmetry",
        "geometry",
        "reflection",
        "math"
      ],
      "name": "Line Symmetry"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "linear-function",
      "keywords": [
        "linear function",
        "slope",
        "y-intercept",
        "coordinate plane",
        "graphing"
      ],
      "name": "Linear Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "linear-pair",
      "keywords": [
        "linear pair",
        "adjacent angles",
        "supplementary angles",
        "geometry",
        "180 degrees"
      ],
      "name": "Linear Pair"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "linear-programming",
      "keywords": [
        "linear programming",
        "optimization",
        "constraints",
        "objective function",
        "feasible solutions"
      ],
      "name": "Linear Programming"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "lines-segments-rays",
      "keywords": [
        "geometry",
        "lines",
        "segments",
        "rays",
        "points"
      ],
      "name": "Lines, Segments, and Rays"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "logarithmic-functions",
      "keywords": [
        "logarithms",
        "functions",
        "graphing",
        "math",
        "algebra"
      ],
      "name": "Logarithmic Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "logarithmic-to-exponential-form",
      "keywords": [
        "logarithms",
        "exponential functions",
        "math transformations",
        "inverse functions",
        "exponents"
      ],
      "name": "Logarithmic to Exponential Form"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "logarithms",
      "keywords": [
        "logarithms",
        "exponents",
        "inverse operations",
        "math",
        "middle school"
      ],
      "name": "Logarithms"
    }
  ],
  "M": [
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "magnitude-and-direction-of-vectors",
      "keywords": [
        "vectors",
        "magnitude",
        "direction",
        "distance formula",
        "trigonometry"
      ],
      "name": "Magnitude and Direction of Vectors"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "major-and-minor-axes-of-conics",
      "keywords": [
        "conics",
        "ellipse",
        "hyperbola",
        "axes",
        "geometry"
      ],
      "name": "Major and Minor Axes of Conics"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "mapping-diagrams",
      "keywords": [
        "mapping diagrams",
        "functions",
        "domain",
        "range",
        "math relations"
      ],
      "name": "Mapping Diagrams"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "matrices",
      "keywords": [
        "keyword1",
        "keyword2",
        "keyword3",
        "keyword4",
        "keyword5"
      ],
      "name": "Matrices"
    },
    {
      "difficulty": "Advanced",
      "iconName": "CircleDot",
      "id": "matrix-multiplication",
      "keywords": [
        "matrix",
        "multiplication",
        "dot product",
        "scalar multiplication",
        "matrices"
      ],
      "name": "Matrix Multiplication"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "matrix-row-operations",
      "keywords": [
        "matrix",
        "row operations",
        "linear equations",
        "identity matrix",
        "matrices"
      ],
      "name": "Matrix Row Operations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "mean",
      "keywords": [
        "average",
        "central tendency",
        "data",
        "mean",
        "statistics"
      ],
      "name": "Mean"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "mean-median-mode",
      "keywords": [
        "mean",
        "median",
        "mode",
        "average",
        "statistics"
      ],
      "name": "Mean, Median, and Mode"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Tangent",
      "id": "weight-mass",
      "keywords": [
        "weight",
        "mass",
        "measurement",
        "metric",
        "customary"
      ],
      "name": "Measurement: Weight and Mass"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "medians-of-a-triangle",
      "keywords": [
        "medians",
        "triangle",
        "geometry",
        "centroid",
        "concurrency"
      ],
      "name": "Medians of a Triangle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "midsegment-of-a-trapezoid",
      "keywords": [
        "trapezoid",
        "midsegment",
        "geometry",
        "parallel sides",
        "formula"
      ],
      "name": "Midsegment of a Trapezoid"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "mixed-expressions",
      "keywords": [
        "mixed expressions",
        "complex fractions",
        "algebra",
        "rational expressions",
        "reciprocals"
      ],
      "name": "Mixed Expressions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "mixed-numbers",
      "keywords": [
        "mixed numbers",
        "fractions",
        "improper fractions",
        "whole numbers",
        "math conversion"
      ],
      "name": "Mixed Number"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "monomials-binomials-polynomials",
      "keywords": [
        "monomials",
        "binomials",
        "polynomials",
        "algebra",
        "expressions"
      ],
      "name": "Monomials, Binomials, Polynomials"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "more-on-hyperbolas",
      "keywords": [
        "hyperbola",
        "foci",
        "asymptotes",
        "vertices",
        "transverse axis"
      ],
      "name": "More on hyperbolas"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "multiplication-rule-of-probability",
      "keywords": [
        "probability",
        "multiplication rule",
        "independent events",
        "dependent events",
        "math"
      ],
      "name": "Multiplication Rule in Probability"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "mixed-numbers-multiplication",
      "keywords": [
        "mixed numbers",
        "multiplication",
        "improper fractions",
        "math practice",
        "simplification"
      ],
      "name": "Multiplication: Mixed Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "multiplication-whole-numbers",
      "keywords": [
        "multiplication",
        "whole numbers",
        "arithmetic",
        "math basics",
        "repeated addition"
      ],
      "name": "Multiplication: Whole Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "multiplying-a-fraction-by-a-fraction",
      "keywords": [
        "Fractions",
        "Multiplication",
        "Mathematics",
        "Numerator",
        "Denominator"
      ],
      "name": "Multiplying a Fraction by a Fraction"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "multiplying-a-fraction-by-an-integer",
      "keywords": [
        "fractions",
        "multiplication",
        "whole numbers",
        "math practice",
        "integers"
      ],
      "name": "Multiplying a Fraction by a Whole Number"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "multiplying-vector-by-a-matrix",
      "keywords": [
        "vector",
        "matrix",
        "linear algebra",
        "multiplication",
        "matrices"
      ],
      "name": "Multiplying a Vector by a Matrix"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "multiplying-and-dividing-with-decimals",
      "keywords": [
        "decimals",
        "multiplication",
        "division",
        "math",
        "students"
      ],
      "name": "Multiplying and Dividing with Decimals"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "multiplying-and-dividing-negatives",
      "keywords": [
        "multiplication",
        "division",
        "negative numbers",
        "math rules",
        "middle school math"
      ],
      "name": "Multiplying and Dividing with Negatives"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "multiplying-complex-numbers",
      "keywords": [
        "complex numbers",
        "FOIL method",
        "imaginary unit",
        "multiplication",
        "i squared"
      ],
      "name": "Multiplying Complex Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "multiplying-decimals",
      "keywords": [
        "multiplying",
        "decimals",
        "math",
        "middle school",
        "practice"
      ],
      "name": "Multiplying Decimals"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "multiplying-monomials",
      "keywords": [
        "multiplying monomials",
        "algebra",
        "product of powers",
        "exponents",
        "math"
      ],
      "name": "Multiplying Monomials"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "multiplying-polynomials",
      "keywords": [
        "polynomials",
        "multiplication",
        "algebra",
        "distributive property",
        "monomials"
      ],
      "name": "Multiplying Polynomials"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "multiplying-rational-expressions",
      "keywords": [
        "rational expressions",
        "multiplication",
        "polynomials",
        "fractions",
        "math"
      ],
      "name": "Multiplying Rational Expressions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "mutually-exclusive-events",
      "keywords": [
        "mutually exclusive",
        "disjoint events",
        "probability",
        "addition rule",
        "real-life examples"
      ],
      "name": "Mutually Exclusive Events"
    }
  ],
  "N": [
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "nth-term-of-a-geometric-sequence",
      "keywords": [
        "geometric sequence",
        "n-th term",
        "common ratio",
        "sequences",
        "mathematics"
      ],
      "name": "n-th Term of a Geometric Sequence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "nth-term-of-a-sequence",
      "keywords": [
        "sequences",
        "n-th term",
        "patterns",
        "mathematics",
        "formulas"
      ],
      "name": "n-th Term of a Sequence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "nth-term-of-an-arithmetic-sequence",
      "keywords": [
        "arithmetic sequence",
        "nth term",
        "common difference",
        "sequence formula",
        "math patterns"
      ],
      "name": "n-th Term of an Arithmetic Sequence"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "natural-logarithm",
      "keywords": [
        "natural logarithm",
        "ln",
        "logarithmic functions",
        "exponential form",
        "mathematical constant e"
      ],
      "name": "Natural Logarithm"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "natural-numbers",
      "keywords": [
        "natural numbers",
        "counting",
        "math basics",
        "number line",
        "whole numbers"
      ],
      "name": "Natural Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "negation",
      "keywords": [
        "negation",
        "logic",
        "mathematics",
        "contradiction",
        "denial"
      ],
      "name": "Negation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "negative-exponents",
      "keywords": [
        "negative exponents",
        "mathematics",
        "reciprocal",
        "powers",
        "exponent rules"
      ],
      "name": "Negative Exponents"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cone",
      "id": "nets",
      "keywords": [
        "nets",
        "geometry",
        "polyhedra",
        "3D shapes",
        "math nets"
      ],
      "name": "Nets"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "normal-distribution-of-data",
      "keywords": [
        "normal distribution",
        "probability distribution",
        "bell curve",
        "mean",
        "standard deviation"
      ],
      "name": "Normal Distribution of Data"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "nth-roots",
      "keywords": [
        "nth roots",
        "mathematics",
        "exponents",
        "roots",
        "real numbers"
      ],
      "name": "nth Roots"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "number-systems",
      "keywords": [
        "number systems",
        "natural numbers",
        "integers",
        "rational numbers",
        "irrational numbers"
      ],
      "name": "Number Systems: Naturals, Integers, Rationals, Irrationals, and Reals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "numerator",
      "keywords": [
        "numerator",
        "fraction",
        "division",
        "math",
        "middle school"
      ],
      "name": "Numerator"
    }
  ],
  "O": [
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "odds",
      "keywords": [
        "odds",
        "probability",
        "theoretical",
        "experimental",
        "ratios"
      ],
      "name": "Odds"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "one-to-one-functions",
      "keywords": [
        "functions",
        "one-to-one",
        "inverses",
        "horizontal line test",
        "math"
      ],
      "name": "One-to-One Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "operations-on-functions",
      "keywords": [
        "functions",
        "operations",
        "composition",
        "math",
        "algebra"
      ],
      "name": "Operations on Functions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "operations-on-mixed-numbers",
      "keywords": [
        "mixed numbers",
        "addition",
        "subtraction",
        "multiplication",
        "division"
      ],
      "name": "Operations on Mixed Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "operations-on-sets",
      "keywords": [
        "sets",
        "union",
        "intersection",
        "difference",
        "complement"
      ],
      "name": "Operations on Sets"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "operations-with-complex-numbers",
      "keywords": [
        "complex numbers",
        "addition",
        "subtraction",
        "multiplication",
        "division"
      ],
      "name": "Operations with Complex Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "operations-with-decimals",
      "keywords": [
        "decimals",
        "addition",
        "subtraction",
        "multiplication",
        "division"
      ],
      "name": "Operations with Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "operations-with-fractions",
      "keywords": [
        "fractions",
        "addition",
        "subtraction",
        "multiplication",
        "division"
      ],
      "name": "Operations with Fractions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "operations-with-negatives",
      "keywords": [
        "negatives",
        "math operations",
        "negative numbers",
        "multiplication",
        "division"
      ],
      "name": "Operations with Negatives"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "opposites",
      "keywords": [
        "mathematics",
        "opposites",
        "additive inverse",
        "number line",
        "middle school"
      ],
      "name": "Opposites"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "order-of-operations",
      "keywords": [
        "order",
        "operations",
        "PEMDAS",
        "math",
        "expressions"
      ],
      "name": "Order of Operations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "CircleDot",
      "id": "ordered-pair",
      "keywords": [
        "ordered pair",
        "coordinates",
        "Cartesian plane",
        "geometry",
        "algebra"
      ],
      "name": "Ordered Pair"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "outliers",
      "keywords": [
        "outliers",
        "mean",
        "median",
        "mode",
        "statistics"
      ],
      "name": "Outliers"
    }
  ],
  "P": [
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "parabolas",
      "keywords": [
        "parabolas",
        "quadratic functions",
        "vertex",
        "graphing",
        "U-shaped curve"
      ],
      "name": "Parabolas"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "parabolas-as-conic-sections",
      "keywords": [
        "parabolas",
        "conic sections",
        "focus",
        "directrix",
        "equations"
      ],
      "name": "Parabolas as Conic Sections"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "FileText",
      "id": "parallel-perpendicular-lines",
      "keywords": [
        "parallel lines",
        "perpendicular lines",
        "geometry",
        "angles",
        "math concepts"
      ],
      "name": "Parallel and Perpendicular Lines"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "parallel-lines",
      "keywords": [
        "parallel lines",
        "geometry",
        "slopes",
        "coplanar",
        "math rules"
      ],
      "name": "Parallel Lines"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "parallel-lines-and-proportionality",
      "keywords": [
        "parallel lines",
        "proportionality",
        "geometry",
        "triangles",
        "ratios"
      ],
      "name": "Parallel Lines and Proportionality"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "parallel-lines-and-transversals",
      "keywords": [
        "parallel lines",
        "proportionality",
        "transversals",
        "geometry",
        "math"
      ],
      "name": "Parallel Lines and Proportionality"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "parallel-lines-and-slopes",
      "keywords": [
        "parallel lines",
        "slopes",
        "geometry",
        "algebra",
        "math"
      ],
      "name": "Parallel Lines and Slopes"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "parallelogram",
      "keywords": [
        "parallelogram",
        "area",
        "perimeter",
        "geometry",
        "quadrilaterals"
      ],
      "name": "Parallelograms: Area and Perimeter"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Box",
      "id": "parametric-equations",
      "keywords": [
        "parametric",
        "equations",
        "rectangular",
        "Cartesian",
        "curve"
      ],
      "name": "Parametric Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "parent-graphs",
      "keywords": [
        "parent graphs",
        "functions",
        "transformations",
        "graphing",
        "mathematics"
      ],
      "name": "Parent Graphs"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Pi",
      "id": "partioning-a-segment-in-a-given-ratio",
      "keywords": [
        "partition",
        "segment",
        "ratio",
        "coordinate plane",
        "geometry"
      ],
      "name": "Partitioning a Segment in a Given Ratio"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "parts-of-an-expression",
      "keywords": [
        "algebra",
        "expressions",
        "terms",
        "coefficients",
        "constants"
      ],
      "name": "Parts of an Expression"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "pascals-triangle",
      "keywords": [
        "Pascal's Triangle",
        "combinatorics",
        "binomial expansion",
        "Zhu Shijie",
        "mathematical patterns"
      ],
      "name": "Pascal's (Zhu Shijie's) Triangle"
    },
    {
      "difficulty": "Beginner",
      "iconName": "PieChart",
      "id": "percent",
      "keywords": [
        "percent",
        "proportion",
        "math",
        "percentage",
        "calculation"
      ],
      "name": "Percent"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "percent-increase-and-decrease",
      "keywords": [
        "percent",
        "increase",
        "decrease",
        "math",
        "proportion"
      ],
      "name": "Percent Increase and Decrease"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "percentile",
      "keywords": [
        "percentile",
        "statistics",
        "rank",
        "score",
        "comparison"
      ],
      "name": "Percentile"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "percents-and-decimals",
      "keywords": [
        "percents",
        "decimals",
        "fractions",
        "conversion",
        "math"
      ],
      "name": "Percents & Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "percents-and-fractions",
      "keywords": [
        "percents",
        "fractions",
        "math",
        "conversion",
        "practice"
      ],
      "name": "Percents & Fractions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "perfect-numbers",
      "keywords": [
        "perfect numbers",
        "integers",
        "divisors",
        "Mersenne primes",
        "Euclid"
      ],
      "name": "Perfect Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "perfect-squares",
      "keywords": [
        "perfect squares",
        "squares",
        "math",
        "numbers",
        "integers"
      ],
      "name": "Perfect Squares"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "perimeter",
      "keywords": [
        "perimeter",
        "geometry",
        "math",
        "polygons",
        "measurement"
      ],
      "name": "Perimeter"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "perimeter-area-volume",
      "keywords": [
        "perimeter",
        "area",
        "volume",
        "geometry",
        "formulas"
      ],
      "name": "Perimeter, Area, and Volume"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "periodic-functions",
      "keywords": [
        "functions",
        "period",
        "cyclic",
        "repetitive",
        "graph"
      ],
      "name": "Periodic Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "permutations",
      "keywords": [
        "permutations",
        "factorial",
        "combinatorics",
        "ordering",
        "arrangement"
      ],
      "name": "Permutations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "perpendicular-bisector",
      "keywords": [
        "geometry",
        "bisector",
        "perpendicular",
        "equidistant",
        "midpoint"
      ],
      "name": "Perpendicular Bisector"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "perpendicular-lines",
      "keywords": [
        "geometry",
        "right angles",
        "perpendicular",
        "lines",
        "math"
      ],
      "name": "Perpendicular Lines"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "perpendicular-lines-and-slopes",
      "keywords": [
        "perpendicular",
        "slopes",
        "geometry",
        "lines",
        "reciprocal"
      ],
      "name": "Perpendicular Lines and Slopes"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "perpendicular-transversal-theorem",
      "keywords": [
        "perpendicular",
        "transversal",
        "theorem",
        "geometry",
        "parallel lines"
      ],
      "name": "Perpendicular Transversal Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Circle",
      "id": "pi",
      "keywords": [
        "Pi",
        "Circumference",
        "Diameter",
        "Irrational Number",
        "Circle"
      ],
      "name": "Pi"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "piecewise-defined-function",
      "keywords": [
        "piecewise",
        "function",
        "math",
        "graph",
        "interval"
      ],
      "name": "Piecewise-Defined Function"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "place-value",
      "keywords": [
        "place value",
        "decimal system",
        "positional notation",
        "math for kids",
        "number systems"
      ],
      "name": "Place Value"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "decimals-an-introduction",
      "keywords": [
        "decimals",
        "place value",
        "fractions",
        "powers of 10",
        "mixed numbers"
      ],
      "name": "Place Value: Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "place-value-decimals",
      "keywords": [
        "decimals",
        "fractions",
        "place value",
        "mixed numbers",
        "powers of 10"
      ],
      "name": "Place Value: Decimals"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Cone",
      "id": "equation-of-a-plane",
      "keywords": [
        "equation of a plane",
        "3D geometry",
        "linear algebra",
        "normal vector",
        "coordinate system"
      ],
      "name": "Planes"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cone",
      "id": "planes",
      "keywords": [
        "equation",
        "plane",
        "3D space",
        "geometry",
        "linear algebra"
      ],
      "name": "Planes"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Cone",
      "id": "platonic-solids",
      "keywords": [
        "Platonic solids",
        "geometry",
        "<a href=\"polyhedra\">polyhedra</a>",
        "regular polygons",
        "3D shapes"
      ],
      "name": "Platonic Solids"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "point-slope-form",
      "keywords": [
        "point-slope form",
        "linear equations",
        "slope",
        "coordinates",
        "graphing"
      ],
      "name": "Point-Slope Form"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "polar-coordinates",
      "keywords": [
        "polar coordinates",
        "math",
        "geometry",
        "trigonometry",
        "coordinate system"
      ],
      "name": "Polar Coordinates"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "polar-form-of-a-complex-number",
      "keywords": [
        "polar form",
        "complex numbers",
        "coordinates",
        "trigonometry",
        "mathematics"
      ],
      "name": "Polar Form of a Complex Number"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Sigma",
      "id": "polygon-exterior-angle-sum-theorem",
      "keywords": [
        "polygon",
        "exterior angles",
        "sum theorem",
        "geometry",
        "angle measures"
      ],
      "name": "Polygon Exterior Angle Sum Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "polygon-interior-angles-sum-theorem",
      "keywords": [
        "polygon",
        "interior angles",
        "geometry",
        "theorem",
        "math"
      ],
      "name": "Polygon Interior Angles Sum Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "polygons",
      "keywords": [
        "polygons",
        "geometry",
        "shapes",
        "sides",
        "angles"
      ],
      "name": "Polygons"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Cone",
      "id": "polyhedra",
      "keywords": [
        "polyhedra",
        "geometry",
        "platonic solids",
        "Euler's formula",
        "3D shapes"
      ],
      "name": "Polyhedra"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "polynomial-function",
      "keywords": [
        "polynomial",
        "functions",
        "degree",
        "constant",
        "exponents"
      ],
      "name": "Polynomial Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "polynomials-with-complex-roots",
      "keywords": [
        "polynomials",
        "complex roots",
        "algebra",
        "quadratic equations",
        "math"
      ],
      "name": "Polynomials with Complex Roots"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "power-of-a-power-property",
      "keywords": [
        "exponent",
        "power",
        "multiplication",
        "property",
        "algebra"
      ],
      "name": "Power of a Power Property"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "power-of-a-product-property",
      "keywords": [
        "exponents",
        "power of a product",
        "math property",
        "math rules",
        "algebra"
      ],
      "name": "Power of a Product Property of Exponents"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "power-of-a-quotient-property",
      "keywords": [
        "quotient",
        "exponents",
        "power property",
        "division",
        "mathematics"
      ],
      "name": "Power of a Quotient Property"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "power-series-and-radius-of-convergence",
      "keywords": [
        "power series",
        "radius of convergence",
        "convergent series",
        "divergent series",
        "partial sums"
      ],
      "name": "Power Series and Radius of Convergence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "powers-of-10",
      "keywords": [
        "powers",
        "exponents",
        "base 10",
        "scientific notation",
        "math"
      ],
      "name": "Powers of 10"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "powers-of-i",
      "keywords": [
        "powers",
        "imaginary unit",
        "complex numbers",
        "i cycle",
        "math powers"
      ],
      "name": "Powers of i"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "prime-composite",
      "keywords": [
        "prime numbers",
        "composite numbers",
        "divisors",
        "math",
        "number theory"
      ],
      "name": "Prime & Composite Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "principal-value-of-a-square-root",
      "keywords": [
        "square roots",
        "principal value",
        "positive root",
        "equations",
        "mathematics"
      ],
      "name": "Principal Value of a Square Root"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "prism",
      "keywords": [
        "prism",
        "geometry",
        "volume",
        "surface area",
        "polyhedron"
      ],
      "name": "Prism"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "probability",
      "keywords": [
        "probability",
        "chance",
        "statistics",
        "math",
        "middle school"
      ],
      "name": "Probability"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "probability-distribution",
      "keywords": [
        "probability",
        "distribution",
        "random variable",
        "sample space",
        "binomial"
      ],
      "name": "Probability Distribution"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "probability-models",
      "keywords": [
        "probability",
        "models",
        "sample space",
        "outcomes",
        "chances"
      ],
      "name": "Probability Models"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Sigma",
      "id": "product-of-a-sum-and-a-difference",
      "keywords": [
        "product",
        "sum",
        "difference",
        "FOIL",
        "binomials"
      ],
      "name": "Product of a Sum and a Difference"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "product-of-powers-property",
      "keywords": [
        "product of powers",
        "exponents",
        "algebra",
        "math property",
        "power rules"
      ],
      "name": "Product of Powers Property"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "properties-of-addition",
      "keywords": [
        "addition",
        "mathematics",
        "commutative",
        "associative",
        "identity"
      ],
      "name": "Properties of Addition"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "properties-of-congruence",
      "keywords": [
        "congruence",
        "geometry",
        "angles",
        "triangles",
        "properties"
      ],
      "name": "Properties of Congruence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "properties-of-equality",
      "keywords": [
        "properties",
        "equality",
        "real numbers",
        "equivalence",
        "manipulate equations"
      ],
      "name": "Properties of Equality"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "properties-of-exponents",
      "keywords": [
        "exponents",
        "base",
        "power",
        "product",
        "quotient"
      ],
      "name": "Properties of Exponents"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "properties-of-inequality",
      "keywords": [
        "inequality",
        "properties",
        "math",
        "middle school",
        "real numbers"
      ],
      "name": "Properties of Inequality"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "properties-of-multiplication",
      "keywords": [
        "multiplication",
        "math properties",
        "identity property",
        "inverse property",
        "multiplicative property of zero"
      ],
      "name": "Properties of Multiplication"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "properties-of-square-roots",
      "keywords": [
        "square roots",
        "product property",
        "quotient property",
        "mathematics",
        "real numbers"
      ],
      "name": "Properties of Square Roots"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "proportional-relationships",
      "keywords": [
        "proportional",
        "relationship",
        "constant",
        "variation",
        "direct"
      ],
      "name": "Proportional Relationships"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "proportions",
      "keywords": [
        "proportions",
        "ratios",
        "math",
        "cross-multiplication",
        "word problems"
      ],
      "name": "Proportions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "pyramid",
      "keywords": [
        "pyramid",
        "geometry",
        "surface area",
        "volume",
        "triangular faces"
      ],
      "name": "Pyramid"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "pythagorean-theorem",
      "keywords": [
        "Pythagorean",
        "Theorem",
        "Right Triangle",
        "Geometry",
        "Hypotenuse"
      ],
      "name": "Pythagorean Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "pythagorean-triples",
      "keywords": [
        "Pythagorean",
        "triples",
        "right triangle",
        "geometry",
        "math"
      ],
      "name": "Pythagorean Triples"
    }
  ],
  "Q": [
    {
      "difficulty": "Beginner",
      "iconName": "CircleDot",
      "id": "quadrants",
      "keywords": [
        "quadrants",
        "cartesian plane",
        "coordinates",
        "x-axis",
        "y-axis"
      ],
      "name": "Quadrants"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "quadratic-equations",
      "keywords": [
        "quadratic",
        "equations",
        "variables",
        "parabolas",
        "algebra"
      ],
      "name": "Quadratic Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "quadratic-formula",
      "keywords": [
        "quadratic",
        "formula",
        "equations",
        "roots",
        "solutions"
      ],
      "name": "Quadratic Formula"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "quadratic-function",
      "keywords": [
        "quadratic",
        "functions",
        "parabola",
        "vertex",
        "graph"
      ],
      "name": "Quadratic Function"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "quadratic-regression",
      "keywords": [
        "quadratic",
        "regression",
        "parabola",
        "least squares",
        "statistics"
      ],
      "name": "Quadratic Regression"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "quadrilaterals",
      "keywords": [
        "quadrilaterals",
        "geometry",
        "parallelogram",
        "rectangle",
        "rhombus"
      ],
      "name": "Quadrilaterals: Classification"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "quartiles",
      "keywords": [
        "quartiles",
        "median",
        "interquartile range",
        "statistics",
        "percentiles"
      ],
      "name": "Quartiles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "quotient-of-powers-property",
      "keywords": [
        "quotient",
        "powers",
        "exponents",
        "division",
        "mathematics"
      ],
      "name": "Quotient of Powers Property"
    }
  ],
  "R": [
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "radian-measure-of-an-angle",
      "keywords": [
        "radian",
        "angle",
        "circle",
        "central angle",
        "arc"
      ],
      "name": "Radian Measure of an Angle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "radian-to-degree-measure",
      "keywords": [
        "radian",
        "degree",
        "angle",
        "conversion",
        "geometry"
      ],
      "name": "Radian to Degree Measure"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Circle",
      "id": "radius",
      "keywords": [
        "geometry",
        "circle",
        "radius",
        "circumference",
        "pi"
      ],
      "name": "Radius"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Infinity",
      "id": "radius-of-convergence",
      "keywords": [
        "power series",
        "radius of convergence",
        "infinite series",
        "disk of convergence",
        "mathematical analysis"
      ],
      "name": "Radius of Convergence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "random-sampling",
      "keywords": [
        "random",
        "sampling",
        "statistics",
        "population",
        "data"
      ],
      "name": "Random Sampling"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "random-variable",
      "keywords": [
        "random variable",
        "probability",
        "statistics",
        "discrete",
        "continuous"
      ],
      "name": "Random Variable"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "range-of-data",
      "keywords": [
        "range",
        "data",
        "statistics",
        "difference",
        "numerical"
      ],
      "name": "Range (of Data)"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "rate-of-change",
      "keywords": [
        "rate of change",
        "mathematics",
        "functions",
        "ratios",
        "graphing"
      ],
      "name": "Rate of Change"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "rate-time-distance-problems",
      "keywords": [
        "rate",
        "time",
        "distance",
        "speed",
        "travel"
      ],
      "name": "Rate-Time-Distance Problems"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "rates",
      "keywords": [
        "rates",
        "ratios",
        "unit rates",
        "real-world",
        "math"
      ],
      "name": "Rates"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "rates-ratios",
      "keywords": [
        "ratios",
        "rates",
        "mathematics",
        "fractions",
        "proportions"
      ],
      "name": "Rates & Ratios"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "rational-exponents",
      "keywords": [
        "rational exponents",
        "fractional exponents",
        "radicals",
        "math",
        "exponents"
      ],
      "name": "Rational Exponents"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "rational-functions",
      "keywords": [
        "rational functions",
        "polynomials",
        "math challenges",
        "fractions",
        "functions"
      ],
      "name": "Rational Functions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "rational-numbers",
      "keywords": [
        "rational numbers",
        "fractions",
        "integers",
        "mixed numbers",
        "decimals"
      ],
      "name": "Rational Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "rationalizing-the-denominator",
      "keywords": [
        "rationalizing",
        "denominator",
        "radicals",
        "conjugate",
        "algebra"
      ],
      "name": "Rationalizing the Denominator"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "rationalizing-the-denominator-by-multiplying-by-a-conjugate",
      "keywords": [
        "rationalizing",
        "denominator",
        "conjugate",
        "difference of squares",
        "radicals"
      ],
      "name": "Rationalizing the Denominator by Multiplying by a Conjugate"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "rationals",
      "keywords": [
        "rational numbers",
        "fractions",
        "ratios",
        "integers",
        "math operations"
      ],
      "name": "Rationals (Advanced)"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "ratios",
      "keywords": [
        "ratios",
        "fractions",
        "comparison",
        "mathematics",
        "middle school"
      ],
      "name": "Ratios"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "real-numbers",
      "keywords": [
        "real numbers",
        "rational numbers",
        "irrational numbers",
        "continuous quantities",
        "number system"
      ],
      "name": "Real Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "real-zero-of-a-function",
      "keywords": [
        "real zero",
        "function",
        "roots",
        "polynomials",
        "algebra"
      ],
      "name": "Real Zero of a Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "big-and-small-numbers",
      "keywords": [
        "big numbers",
        "small numbers",
        "exponents",
        "scientific notation",
        "international number naming"
      ],
      "name": "Really Big and Really Small Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "FileText",
      "id": "reciprocals",
      "keywords": [
        "reciprocals",
        "multiplicative inverse",
        "fractions",
        "inverse",
        "math concepts"
      ],
      "name": "Reciprocals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Cylinder",
      "id": "rectangle",
      "keywords": [
        "rectangles",
        "geometry",
        "area",
        "perimeter",
        "shapes"
      ],
      "name": "Rectangles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "recursive-sequence",
      "keywords": [
        "recursive",
        "sequence",
        "arithmetic",
        "geometric",
        "math"
      ],
      "name": "Recursive Sequence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "reduced-radical-form",
      "keywords": [
        "reduced radicals",
        "square roots",
        "perfect squares",
        "radicand",
        "simplifying radicals"
      ],
      "name": "Reduced Radical Form"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "reducing-fractions",
      "keywords": [
        "fractions",
        "simplest form",
        "greatest common factor",
        "numerator",
        "denominator"
      ],
      "name": "Reducing Fractions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "reference-angle",
      "keywords": [
        "reference angle",
        "geometry",
        "angles",
        "trigonometry",
        "math"
      ],
      "name": "Reference Angle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "reflections",
      "keywords": [
        "reflections",
        "geometry",
        "transformations",
        "mirror line",
        "congruent shapes"
      ],
      "name": "Reflections"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "reflexive-symmetric-transitive-properties",
      "keywords": [
        "reflexive",
        "symmetric",
        "transitive",
        "substitution",
        "properties"
      ],
      "name": "Reflexive, Symmetric, Transitive, and Substitution Properties"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "relations",
      "keywords": [
        "relations",
        "ordered pairs",
        "domain",
        "range",
        "mathematics"
      ],
      "name": "Relations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "relatively-prime",
      "keywords": [
        "relatively prime",
        "polynomials",
        "greatest common factor",
        "prime numbers",
        "number theory"
      ],
      "name": "Relatively Prime Numbers and Polynomials"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "repeated-zeros",
      "keywords": [
        "repeated zeros",
        "polynomials",
        "factoring",
        "math",
        "zeros"
      ],
      "name": "Repeated Zeros"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "representing-systems-of-linear-equations-using-matrices",
      "keywords": [
        "matrices",
        "linear equations",
        "systems",
        "math",
        "education"
      ],
      "name": "Representing Systems of Linear Equations using Matrices"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "rhombus",
      "keywords": [
        "geometry",
        "rhombus",
        "parallelogram",
        "congruent",
        "area"
      ],
      "name": "Rhombus"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "right-triangle-congruence",
      "keywords": [
        "right triangle",
        "congruence",
        "geometry",
        "triangle properties",
        "hypotenuse"
      ],
      "name": "Right Triangle Congruence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "right-triangle-similarity",
      "keywords": [
        "geometry",
        "triangles",
        "similarity",
        "math",
        "education"
      ],
      "name": "Right Triangle Similarity"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "root",
      "keywords": [
        "polynomials",
        "roots",
        "algebra",
        "equations",
        "math"
      ],
      "name": "Roots"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "rotational-symmetry",
      "keywords": [
        "rotational symmetry",
        "geometry",
        "angles",
        "polygons",
        "math symmetry"
      ],
      "name": "Rotational Symmetry"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "rotations",
      "keywords": [
        "rotations",
        "geometry",
        "transformation",
        "angles",
        "degrees"
      ],
      "name": "Rotations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "rounding-decimals",
      "keywords": [
        "rounding",
        "decimals",
        "math",
        "place value",
        "approximation"
      ],
      "name": "Rounding Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "rounding-numbers",
      "keywords": [
        "rounding",
        "place value",
        "math",
        "estimation",
        "accuracy"
      ],
      "name": "Rounding Numbers"
    }
  ],
  "S": [
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "sample-space",
      "keywords": [
        "sample space",
        "probability",
        "outcomes",
        "experiments",
        "math"
      ],
      "name": "Sample Space"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "sas-postulate",
      "keywords": [
        "geometry",
        "congruence",
        "triangles",
        "SAS postulate",
        "side-angle-side"
      ],
      "name": "SAS (Side-Angle-Side) Postulate"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "sas-inequality",
      "keywords": [
        "SAS Inequality",
        "Triangles",
        "Geometry",
        "Side-Angle-Side",
        "Math"
      ],
      "name": "SAS Inequality"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "scalar-multiplication-of-matrices",
      "keywords": [
        "matrices",
        "scalar",
        "multiplication",
        "math",
        "education"
      ],
      "name": "Scalar Multiplication of Matrices"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "scalar-multiplication-of-vectors",
      "keywords": [
        "scalar",
        "vectors",
        "multiplication",
        "magnitude",
        "direction"
      ],
      "name": "Scalar Multiplication of Vectors"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "scale-drawings",
      "keywords": [
        "scale drawings",
        "scale factor",
        "geometry",
        "proportionality",
        "modeling"
      ],
      "name": "Scale Drawings"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "scale-factor",
      "keywords": [
        "scale factor",
        "geometry",
        "similar figures",
        "ratios",
        "dilation"
      ],
      "name": "Scale Factor"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "scalene-triangle",
      "keywords": [
        "scalene triangle",
        "geometry",
        "triangle properties",
        "triangle types",
        "angles"
      ],
      "name": "Scalene Triangle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "scatter-plots",
      "keywords": [
        "scatter plots",
        "correlations",
        "ordered pairs",
        "data visualization",
        "coordinate plane"
      ],
      "name": "Scatter Plots"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "scientific-notation",
      "keywords": [
        "scientific",
        "notation",
        "exponents",
        "powers of ten",
        "mathematics"
      ],
      "name": "Scientific Notation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "sectors",
      "keywords": [
        "sectors",
        "geometry",
        "circles",
        "central angle",
        "intercepted arc"
      ],
      "name": "Sectors"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "segment-addition-postulate",
      "keywords": [
        "segment",
        "addition",
        "postulate",
        "geometry",
        "math"
      ],
      "name": "Segment Addition Postulate"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Infinity",
      "id": "sequence",
      "keywords": [
        "sequence",
        "term",
        "finite",
        "infinite",
        "increasing"
      ],
      "name": "Sequence"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "series",
      "keywords": [
        "series",
        "summation",
        "sequence",
        "sigma notation",
        "finite series"
      ],
      "name": "Series"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "sets",
      "keywords": [
        "sets",
        "collections",
        "roster method",
        "set-builder method",
        "statistics"
      ],
      "name": "Sets"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Circle",
      "id": "shortest-distance-between-a-point-and-a-circle",
      "keywords": [
        "geometry",
        "distance",
        "circle",
        "point",
        "math"
      ],
      "name": "Shortest Distance between a Point and a Circle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "sas-similarity",
      "keywords": [
        "SAS",
        "similarity",
        "triangles",
        "geometry",
        "proportions"
      ],
      "name": "Side-Angle-Side Similarity"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "side-angle-side-similarity",
      "keywords": [
        "SAS",
        "triangle similarity",
        "geometry",
        "proportional sides",
        "congruent angles"
      ],
      "name": "Side-Angle-Side Similarity"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "side-side-side-similarity",
      "keywords": [
        "SSS",
        "triangle similarity",
        "proportional sides",
        "geometry",
        "math"
      ],
      "name": "Side-Side-Side Similarity"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "sss-similarity",
      "keywords": [
        "SSS",
        "triangle similarity",
        "geometry",
        "proportionality",
        "congruent triangles"
      ],
      "name": "Side-Side-Side Similarity"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "sigma-notation-of-a-series",
      "keywords": [
        "sigma",
        "series",
        "notation",
        "sum",
        "compact representation"
      ],
      "name": "Sigma Notation of a Series"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "significant-digits",
      "keywords": [
        "significant digits",
        "significant figures",
        "measurement accuracy",
        "math rules",
        "decimal points"
      ],
      "name": "Significant Digits"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "similar-figures",
      "keywords": [
        "geometry",
        "similarity",
        "scale factor",
        "ratios",
        "congruent angles"
      ],
      "name": "Similar Figures"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "similar-triangles",
      "keywords": [
        "triangles",
        "geometry",
        "proportions",
        "scale factor",
        "congruent angles"
      ],
      "name": "Similar Triangles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "simple-interest",
      "keywords": [
        "simple interest",
        "interest formula",
        "financial math",
        "loans",
        "bank savings"
      ],
      "name": "Simple Interest"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "simplifying-absolute-value-expressions",
      "keywords": [
        "absolute value",
        "real numbers",
        "integers",
        "modulus",
        "distance from zero"
      ],
      "name": "Simplifying Absolute Value Expressions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "simplifying-expressions",
      "keywords": [
        "simplifying",
        "expressions",
        "algebra",
        "distributive property",
        "FOIL method"
      ],
      "name": "Simplifying Expressions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "simplifying-logarithmic-expressions",
      "keywords": [
        "logarithms",
        "simplifying expressions",
        "properties of logarithms",
        "exponents",
        "math for kids"
      ],
      "name": "Simplifying Logarithmic Expressions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "simplifying-radical-expressions",
      "keywords": [
        "radicals",
        "square roots",
        "simplifying",
        "algebra",
        "math"
      ],
      "name": "Simplifying Radical Expressions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "simplifying-radical-expressions-involving-products",
      "keywords": [
        "radicals",
        "simplifying",
        "math",
        "expressions",
        "products"
      ],
      "name": "Simplifying Radical Expressions Involving Products"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "simplifying-radical-expressions-with-variables",
      "keywords": [
        "Radicals",
        "Variables",
        "Simplification",
        "Algebra",
        "Square Roots"
      ],
      "name": "Simplifying Radical Expressions with Variables"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "simplifying-rational-expressions",
      "keywords": [
        "rational expressions",
        "polynomials",
        "simplification",
        "math",
        "fractions"
      ],
      "name": "Simplifying Rational Expressions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "simplifying-square-roots",
      "keywords": [
        "square roots",
        "perfect squares",
        "radical",
        "estimation",
        "math basics"
      ],
      "name": "Simplifying Square Roots"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "sine",
      "keywords": [
        "sine",
        "trigonometry",
        "right triangle",
        "hypotenuse",
        "opposite"
      ],
      "name": "Sine"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "sine-function",
      "keywords": [
        "sine",
        "trigonometry",
        "unit circle",
        "periodic function",
        "angles"
      ],
      "name": "Sine Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Pyramid",
      "id": "slant-height-of-a-pyramid",
      "keywords": [
        "slant height",
        "pyramid",
        "geometry",
        "lateral face",
        "altitude"
      ],
      "name": "Slant Height of a Pyramid"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "slope",
      "keywords": [
        "slope",
        "linear equations",
        "steepness",
        "y-intercepts",
        "parallel lines"
      ],
      "name": "Slope of a Line"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "slope-intercept-form",
      "keywords": [
        "slope",
        "intercept",
        "linear equations",
        "graphing",
        "y-axis"
      ],
      "name": "Slope-Intercept Form"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "solution-sets",
      "keywords": [
        "solution sets",
        "equations",
        "inequalities",
        "mathematics",
        "problem solving"
      ],
      "name": "Solution Sets"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "solving-absolute-value-equations",
      "keywords": [
        "absolute value",
        "equations",
        "math problems",
        "distance",
        "number line"
      ],
      "name": "Solving Absolute Value Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "solving-equations",
      "keywords": [
        "solving",
        "equations",
        "variables",
        "solutions",
        "math"
      ],
      "name": "Solving Equations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Variable",
      "id": "solving-equations-basic",
      "keywords": [
        "solving equations",
        "basic algebra",
        "math practice",
        "equations",
        "variables"
      ],
      "name": "Solving Equations: Basic"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "solving-exponential-equations",
      "keywords": [
        "exponential",
        "equations",
        "solving",
        "math",
        "education"
      ],
      "name": "Solving Exponential Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "solving-exponential-equations-using-logarithms",
      "keywords": [
        "exponential",
        "equations",
        "logarithms",
        "math",
        "solving"
      ],
      "name": "Solving Exponential Equations using Logarithms"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "solving-linear-equations",
      "keywords": [
        "linear equations",
        "inverse operations",
        "solving equations",
        "variables",
        "algebra"
      ],
      "name": "Solving Linear Equations: All Types"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-linear-inequalities",
      "keywords": [
        "linear inequalities",
        "math inequalities",
        "solving inequalities",
        "inequality properties",
        "math practice"
      ],
      "name": "Solving Linear Inequalities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "solving-linear-quadratic-systems",
      "keywords": [
        "linear equations",
        "quadratic equations",
        "systems of equations",
        "substitution method",
        "quadratic formula"
      ],
      "name": "Solving Linear-Quadratic Systems"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "solving-logarithmic-equations",
      "keywords": [
        "logarithmic equations",
        "exponential form",
        "logarithms",
        "algebra",
        "math practice"
      ],
      "name": "Solving Logarithmic Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "solving-matrix-equations",
      "keywords": [
        "matrix equations",
        "addition",
        "scalar multiplication",
        "linear algebra",
        "math practice"
      ],
      "name": "Solving Matrix Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-multi-step-linear-equations",
      "keywords": [
        "linear equations",
        "multi-step equations",
        "algebra",
        "inverse operations",
        "math practice"
      ],
      "name": "Solving Multi-Step Linear Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-multi-step-linear-equations-with-decimals",
      "keywords": [
        "linear equations",
        "decimals",
        "multi-step",
        "algebra",
        "mathematics"
      ],
      "name": "Solving Multi-Step Linear Equations with Decimals"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-multi-step-linear-equations-with-fractions",
      "keywords": [
        "linear equations",
        "fractions",
        "multi-step equations",
        "inverse operations",
        "least common denominator"
      ],
      "name": "Solving Multi-Step Linear Equations with Fractions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "TrendingUp",
      "id": "solving-one-step-addition-equations",
      "keywords": [
        "addition equations",
        "inverse operations",
        "linear equations",
        "middle school math",
        "basic algebra"
      ],
      "name": "Solving One-Step Addition Equations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "TrendingUp",
      "id": "solving-one-step-division-equations",
      "keywords": [
        "division",
        "one-step equations",
        "inverse operations",
        "algebra",
        "linear equations"
      ],
      "name": "Solving One-Step Division Equations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations",
      "keywords": [
        "linear equations",
        "inverse operations",
        "addition",
        "subtraction",
        "variables"
      ],
      "name": "Solving One-Step Linear Equations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations-with-decimals",
      "keywords": [
        "linear equations",
        "decimals",
        "one-step equations",
        "inverse operations",
        "math practice"
      ],
      "name": "Solving One-Step Linear Equations with Decimals"
    },
    {
      "difficulty": "Beginner",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations-with-fractions",
      "keywords": [
        "linear equations",
        "fractions",
        "inverse operations",
        "one-step equations",
        "math practice"
      ],
      "name": "Solving One-Step Linear Equations with Fractions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations-with-mixed-numbers",
      "keywords": [
        "linear equations",
        "mixed numbers",
        "fractions",
        "algebra",
        "math"
      ],
      "name": "Solving One-Step Linear Equations with Mixed Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations-with-mixed-numbers-addition",
      "keywords": [
        "linear equations",
        "mixed numbers",
        "addition",
        "fractions",
        "math"
      ],
      "name": "Solving One-Step Linear Equations with Mixed Numbers: Addition"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations-with-mixed-numbers-division",
      "keywords": [
        "linear equations",
        "mixed numbers",
        "division",
        "improper fractions",
        "reciprocals"
      ],
      "name": "Solving One-Step Linear Equations with Mixed Numbers: Division"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations-with-mixed-numbers-multiplication",
      "keywords": [
        "linear equations",
        "mixed numbers",
        "multiplication",
        "math",
        "middle school"
      ],
      "name": "Solving One-Step Linear Equations with Mixed Numbers: Multiplication"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-equations-with-mixed-numbers-subtraction",
      "keywords": [
        "linear equations",
        "mixed numbers",
        "subtraction",
        "one-step equations",
        "improper fractions"
      ],
      "name": "Solving One-Step Linear Equations with Mixed Numbers: Subtraction"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-one-step-linear-inequalities",
      "keywords": [
        "linear inequalities",
        "one-step inequalities",
        "inequality symbols",
        "math for teens",
        "solving inequalities"
      ],
      "name": "Solving One-Step Linear Inequalities"
    },
    {
      "difficulty": "Beginner",
      "iconName": "TrendingUp",
      "id": "solving-one-step-multiplication-equations",
      "keywords": [
        "multiplication",
        "equations",
        "one-step",
        "linear equations",
        "inverse operations"
      ],
      "name": "Solving One-Step Multiplication Equations"
    },
    {
      "difficulty": "Beginner",
      "iconName": "TrendingUp",
      "id": "solving-one-step-subtraction-equations",
      "keywords": [
        "subtraction",
        "equations",
        "inverse operations",
        "linear equations",
        "math tricks"
      ],
      "name": "Solving One-Step Subtraction Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "solving-problems-with-vectors",
      "keywords": [
        "vectors",
        "velocity",
        "force",
        "components",
        "resultant"
      ],
      "name": "Solving Problems with Vectors"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "solving-quadratic-equations-using-factoring",
      "keywords": [
        "quadratic equations",
        "factoring",
        "algebra",
        "math problems",
        "mathematics"
      ],
      "name": "Solving Quadratic Equations using Factoring"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "solving-quadratic-equations-by-square-roots",
      "keywords": [
        "quadratic equations",
        "square roots",
        "algebra",
        "math solutions",
        "equation solving"
      ],
      "name": "Solving Quadratic Equations using Square Roots"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "solving-radical-equations",
      "keywords": [
        "radical equations",
        "square roots",
        "mathematics",
        "algebra",
        "solving equations"
      ],
      "name": "Solving Radical Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "solving-rational-equations",
      "keywords": [
        "rational equations",
        "math",
        "algebra",
        "expressions",
        "problem solving"
      ],
      "name": "Solving Rational Equations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "solving-systems-of-linear-equations",
      "keywords": [
        "linear equations",
        "systems of equations",
        "graphing",
        "intersection",
        "parallel lines"
      ],
      "name": "Solving Systems of Linear Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-systems-of-linear-equations-using-elimination",
      "keywords": [
        "linear equations",
        "elimination method",
        "solving systems",
        "math practice",
        "algebra"
      ],
      "name": "Solving Systems of Linear Equations using Elimination"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "solving-systems-of-linear-equations-using-graphing",
      "keywords": [
        "linear equations",
        "graphing method",
        "intersections",
        "systems of equations",
        "algebra"
      ],
      "name": "Solving Systems of Linear Equations using Graphing"
    },
    {
      "difficulty": "Advanced",
      "iconName": "TrendingUp",
      "id": "solving-systems-of-linear-equations-using-matrices",
      "keywords": [
        "matrices",
        "linear equations",
        "systems of equations",
        "matrix method",
        "math solutions"
      ],
      "name": "Solving Systems of Linear Equations using Matrices"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-systems-of-linear-equations-using-substitution",
      "keywords": [
        "substitution",
        "linear equations",
        "systems of equations",
        "algebra",
        "solving equations"
      ],
      "name": "Solving Systems of Linear Equations using Substitution"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "solving-trigonometric-equations-using-algebraic-method",
      "keywords": [
        "trigonometry",
        "algebraic methods",
        "solving equations",
        "math for teens",
        "interactive learning"
      ],
      "name": "Solving Trigonometric Equations using Algebraic Methods"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "solving-trigonometric-equations-using-trigonometric-identities",
      "keywords": [
        "trigonometry",
        "equations",
        "identities",
        "math",
        "solutions"
      ],
      "name": "Solving Trigonometric Equations using Trigonometric Identities"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-two-step-linear-inequalities",
      "keywords": [
        "linear inequalities",
        "two-step equations",
        "inverse operations",
        "variable isolation",
        "math solutions"
      ],
      "name": "Solving Two Step Linear Inequalities"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-two-step-linear-equations",
      "keywords": [
        "two-step equations",
        "linear equations",
        "inverse operations",
        "algebra",
        "solving equations"
      ],
      "name": "Solving Two-Step Linear Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-two-step-linear-equations-with-decimals",
      "keywords": [
        "linear equations",
        "decimals",
        "two-step equations",
        "inverse operations",
        "algebra"
      ],
      "name": "Solving Two-Step Linear Equations with Decimals"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "solving-two-step-linear-equations-with-fractions",
      "keywords": [
        "linear equations",
        "fractions",
        "two-step equations",
        "algebra",
        "math problems"
      ],
      "name": "Solving Two-Step Linear Equations with Fractions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "sphere",
      "keywords": [
        "sphere",
        "geometry",
        "radius",
        "surface area",
        "volume"
      ],
      "name": "Sphere"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "square-matrix",
      "keywords": [
        "square matrix",
        "matrices",
        "main diagonal",
        "matrix order",
        "trace"
      ],
      "name": "Square Matrix"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Radical",
      "id": "square-of-a-binomial",
      "keywords": [
        "square",
        "binomial",
        "trinomial",
        "polynomial",
        "algebra"
      ],
      "name": "Square of a Binomial"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Radical",
      "id": "square-roots",
      "keywords": [
        "square roots",
        "principal square root",
        "irrational numbers",
        "estimation",
        "perfect squares"
      ],
      "name": "Square Roots"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Circle",
      "id": "squares-circumscribed-by-circles",
      "keywords": [
        "squares",
        "circles",
        "geometry",
        "diagonal",
        "Pythagorean theorem"
      ],
      "name": "Squares Circumscribed by Circles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "square",
      "keywords": [
        "squares",
        "geometry",
        "area",
        "perimeter",
        "mathematics"
      ],
      "name": "Squares: Area and Perimeter"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "sss-postulate",
      "keywords": [
        "SSS Postulate",
        "Triangles",
        "Congruence",
        "Geometry",
        "Side-Side-Side"
      ],
      "name": "SSS (Side-Side-Side) Postulate"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "sss-inequality",
      "keywords": [
        "SSS inequality",
        "Hinge Theorem",
        "triangle comparison",
        "geometry",
        "triangle inequality"
      ],
      "name": "SSS Inequality"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "standard-deviation",
      "keywords": [
        "standard deviation",
        "variance",
        "data spread",
        "mean",
        "statistics"
      ],
      "name": "Standard Deviation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "standard-form",
      "keywords": [
        "Standard Form",
        "Linear Equation",
        "Horizontal Lines",
        "Vertical Lines",
        "Equation Form"
      ],
      "name": "Standard Form of a Line"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "statistical-questions",
      "keywords": [
        "statistics",
        "data analysis",
        "statistical questions",
        "central tendency",
        "median"
      ],
      "name": "Statistical Questions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "stem-and-leaf-plots",
      "keywords": [
        "stem",
        "leaf",
        "plots",
        "data",
        "visualization"
      ],
      "name": "Stem-and-Leaf Plots"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "step-function",
      "keywords": [
        "step function",
        "piecewise-defined function",
        "floor function",
        "greatest integer function",
        "staircase function"
      ],
      "name": "Step Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "FileText",
      "id": "subsets",
      "keywords": [
        "subsets",
        "sets",
        "mathematics",
        "set theory",
        "element"
      ],
      "name": "Subsets"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "subtracting-fractions",
      "keywords": [
        "fractions",
        "subtraction",
        "numerator",
        "denominator",
        "math"
      ],
      "name": "Subtracting Fractions"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "subtracting-fractions-like-denominators",
      "keywords": [
        "fractions",
        "subtracting",
        "mathematics",
        "like denominators",
        "numerators"
      ],
      "name": "Subtracting Fractions with Like Denominators"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "subtracting-fractions-unlike-denominators",
      "keywords": [
        "subtracting fractions",
        "unlike denominators",
        "least common multiple",
        "LCM",
        "equivalent fractions"
      ],
      "name": "Subtracting Fractions with Unlike Denominators"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "mixed-numbers-subtraction",
      "keywords": [
        "mixed numbers",
        "subtraction",
        "fractions",
        "improper fractions",
        "mathematics"
      ],
      "name": "Subtraction: Mixed Numbers"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "subtraction-whole-numbers",
      "keywords": [
        "subtraction",
        "whole numbers",
        "borrowing",
        "math skills",
        "real life application"
      ],
      "name": "Subtraction: Whole Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "sum-and-difference-identities",
      "keywords": [
        "trigonometry",
        "sum identities",
        "difference identities",
        "sine",
        "cosine"
      ],
      "name": "Sum and Difference Identities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Box",
      "id": "sum-and-difference-of-cubes",
      "keywords": [
        "factorization",
        "cubes",
        "algebra",
        "polynomials",
        "mnemonics"
      ],
      "name": "Sum and Difference of Cubes"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "sum-of-the-first-n-terms-of-a-geometric-sequence",
      "keywords": [
        "geometric sequence",
        "sum",
        "series",
        "common ratio",
        "infinite series"
      ],
      "name": "Sum of the First n Terms of a Geometric Sequence"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "sum-of-the-first-n-terms-of-a-geometric-series",
      "keywords": [
        "geometric series",
        "sum of series",
        "mathematical sequences",
        "common ratio",
        "geometric progression"
      ],
      "name": "Sum of the First n Terms of a Geometric Series"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "sum-of-the-first-n-terms-of-a-series",
      "keywords": [
        "arithmetic series",
        "geometric series",
        "sequence",
        "sum",
        "mathematics"
      ],
      "name": "Sum of the First n Terms of a Series"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "sum-of-the-first-n-terms-of-an-arithmetic-sequence",
      "keywords": [
        "arithmetic sequence",
        "partial sum",
        "series",
        "math",
        "formula"
      ],
      "name": "Sum of the First n Terms of an Arithmetic Sequence"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "sum-of-the-first-n-terms-of-an-arithmetic-series",
      "keywords": [
        "arithmetic series",
        "sum of terms",
        "sequence",
        "formula",
        "math"
      ],
      "name": "Sum of the First n Terms of an Arithmetic Series"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "supplement-postulate",
      "keywords": [
        "supplement",
        "postulate",
        "angles",
        "geometry",
        "linear pair"
      ],
      "name": "Supplement Postulate"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "supplementary-angles",
      "keywords": [
        "angles",
        "geometry",
        "supplementary",
        "linear pairs",
        "adjacent"
      ],
      "name": "Supplementary Angles"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "surface-area",
      "keywords": [
        "surface area",
        "geometry",
        "lateral area",
        "pyramid",
        "cylinder"
      ],
      "name": "Surface Area"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "surface-area-of-a-cone",
      "keywords": [
        "surface area",
        "cone",
        "geometry",
        "math",
        "formula"
      ],
      "name": "Surface Area of a Cone"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "surface-area-of-a-cylinder",
      "keywords": [
        "cylinder",
        "surface area",
        "geometry",
        "lateral area",
        "total area"
      ],
      "name": "Surface Area of a Cylinder"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "surface-area-of-a-prism",
      "keywords": [
        "surface area",
        "prism",
        "geometry",
        "math",
        "measurement"
      ],
      "name": "Surface Area of a Prism"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Pyramid",
      "id": "surface-area-of-a-pyramid",
      "keywords": [
        "pyramid",
        "surface area",
        "geometry",
        "lateral area",
        "base area"
      ],
      "name": "Surface Area of a Pyramid"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "surface-area-of-a-sphere",
      "keywords": [
        "surface area",
        "sphere",
        "geometry",
        "3D shapes",
        "Archimedes"
      ],
      "name": "Surface Area of a Sphere"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "symbolic-logic",
      "keywords": [
        "symbolic logic",
        "conjunction",
        "disjunction",
        "negation",
        "truth tables"
      ],
      "name": "Symbolic Logic"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "systems-of-linear-inequalities",
      "keywords": [
        "linear inequalities",
        "graphing",
        "systems",
        "algebra",
        "math"
      ],
      "name": "Systems of Linear Inequalities"
    }
  ],
  "T": [
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "tangent-of-an-angle",
      "keywords": [
        "tangent",
        "trigonometry",
        "right triangle",
        "ratios",
        "cotangent"
      ],
      "name": "Tangent (of an angle)"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "tangent-function",
      "keywords": [
        "trigonometry",
        "tangent",
        "unit circle",
        "angles",
        "periodic functions"
      ],
      "name": "Tangent Function"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Tangent",
      "id": "tangent-line",
      "keywords": [
        "tangent",
        "geometry",
        "tangent line",
        "circle",
        "point of tangency"
      ],
      "name": "Tangent Line"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Tangent",
      "id": "tangent-to-a-circle",
      "keywords": [
        "tangent",
        "circle",
        "geometry",
        "perpendicular",
        "Pythagorean theorem"
      ],
      "name": "Tangent to a Circle"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Sigma",
      "id": "taylor-series",
      "keywords": [
        "Taylor Series",
        "Infinite Sum",
        "Derivatives",
        "Polynomial Approximation",
        "Mathematics"
      ],
      "name": "Taylor Series"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "temperature",
      "keywords": [
        "temperature",
        "Celsius",
        "Fahrenheit",
        "conversion",
        "thermometer"
      ],
      "name": "Temperature"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "term-of-a-sequence",
      "keywords": [
        "sequence",
        "term",
        "pattern",
        "arithmetic sequence",
        "mathematics"
      ],
      "name": "Term of a Sequence"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "terminating-and-repeating-decimals",
      "keywords": [
        "decimals",
        "fractions",
        "math",
        "rational numbers",
        "division"
      ],
      "name": "Terminating and Repeating Decimals"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "tessellations",
      "keywords": [
        "tessellations",
        "geometry",
        "patterns",
        "plane",
        "shapes"
      ],
      "name": "Tessellations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Pi",
      "id": "associative-laws",
      "keywords": [
        "associative",
        "addition",
        "multiplication",
        "properties",
        "grouping"
      ],
      "name": "The Associative Laws (or Properties) of Addition and Multiplication"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "binomial-theorem",
      "keywords": [
        "binomial",
        "theorem",
        "polynomial",
        "algebra",
        "exponents"
      ],
      "name": "The Binomial Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "cartesian-plane",
      "keywords": [
        "Cartesian plane",
        "coordinates",
        "ordered pair",
        "x-axis",
        "y-axis"
      ],
      "name": "The Cartesian Plane"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "cofunction-and-odd-even-identities",
      "keywords": [
        "Cofunction Identities",
        "Odd-Even Identities",
        "Trigonometry",
        "Sine",
        "Cosine"
      ],
      "name": "The Cofunction and Odd-Even Identities"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "commutative-laws",
      "keywords": [
        "commutative property",
        "addition",
        "multiplication",
        "math properties",
        "real numbers"
      ],
      "name": "The Commutative Laws (or Properties) of Addition and Multiplication"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "converse-of-pythagorean-theorem",
      "keywords": [
        "Pythagorean",
        "Converse",
        "Right Triangle",
        "Geometry",
        "Triangles"
      ],
      "name": "The Converse of Pythagorean Theorem"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "discriminant",
      "keywords": [
        "discriminant",
        "quadratic equations",
        "real solutions",
        "complex solutions",
        "math learning"
      ],
      "name": "The Discriminant"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "distance-formula",
      "keywords": [
        "distance formula",
        "Pythagorean theorem",
        "geometry",
        "cartesian plane",
        "math"
      ],
      "name": "The Distance Formula"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Cone",
      "id": "distance-formula-in-3d",
      "keywords": [
        "distance formula",
        "3D space",
        "geometry",
        "coordinates",
        "math"
      ],
      "name": "The Distance Formula in 3 Dimensions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "distributive-property",
      "keywords": [
        "distributive property",
        "algebra",
        "mathematics",
        "equations",
        "multiplication"
      ],
      "name": "The Distributive Property"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "factor-theorem",
      "keywords": [
        "Factor Theorem",
        "Polynomial Division",
        "Remainder Theorem",
        "Algebra",
        "Mathematics"
      ],
      "name": "The Factor Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "median",
      "keywords": [
        "median",
        "statistics",
        "data set",
        "percentile",
        "middle value"
      ],
      "name": "The Median"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Tangent",
      "id": "metric-system",
      "keywords": [
        "metric",
        "measurement",
        "powers of 10",
        "units",
        "conversion"
      ],
      "name": "The Metric System"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "midpoint-formula",
      "keywords": [
        "midpoint",
        "geometry",
        "line segment",
        "average",
        "coordinate"
      ],
      "name": "The Midpoint Formula"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "mode",
      "keywords": [
        "mode",
        "statistics",
        "central tendency",
        "bi-modal",
        "tri-modal"
      ],
      "name": "The Mode"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "number-line",
      "keywords": [
        "number line",
        "real numbers",
        "integers",
        "positive numbers",
        "negative numbers"
      ],
      "name": "The Number Line"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "prime-page",
      "keywords": [
        "prime numbers",
        "number theory",
        "cryptography",
        "mathematics",
        "composite numbers"
      ],
      "name": "The Prime Page"
    },
    {
      "difficulty": "Advanced",
      "iconName": "SquareFunction",
      "id": "remainder-theorem",
      "keywords": [
        "Remainder Theorem",
        "polynomials",
        "division",
        "math",
        "functions"
      ],
      "name": "The Remainder Theorem"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "sum-to-product-and-product-to-sum-identities",
      "keywords": [
        "sum-to-product",
        "product-to-sum",
        "trigonometric identities",
        "math transformations",
        "trigonometry"
      ],
      "name": "The Sum-to-Product and Product-to-Sum Identities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "vertex-of-a-parabola",
      "keywords": [
        "parabola",
        "vertex",
        "quadratic",
        "axis of symmetry",
        "graph"
      ],
      "name": "The Vertex of a Parabola"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "vertical-line-test",
      "keywords": [
        "vertical line test",
        "function graph",
        "math test",
        "functions",
        "graph intersections"
      ],
      "name": "The Vertical Line Test"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "zero-product-property",
      "keywords": [
        "zero product property",
        "quadratic equations",
        "factoring",
        "algebra",
        "math"
      ],
      "name": "The Zero Product Property"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Pi",
      "id": "transcendental-numbers",
      "keywords": [
        "transcendental",
        "numbers",
        "irrational",
        "Euler",
        "polynomial"
      ],
      "name": "Transcendental Numbers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "transformations-of-functions",
      "keywords": [
        "transformations",
        "functions",
        "horizontal shifts",
        "parent graph",
        "Cartesian plane"
      ],
      "name": "Transformation of Function"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "transformation-of-graphs-using-matrices-reflection",
      "keywords": [
        "transformation",
        "matrices",
        "reflection",
        "graphs",
        "math"
      ],
      "name": "Transformation of Graphs Using Matrices -  Reflection"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "transformation-of-graphs-using-matrices-rotations",
      "keywords": [
        "transformation",
        "matrices",
        "rotation",
        "graphs",
        "geometry"
      ],
      "name": "Transformation of Graphs Using Matrices -  Rotations"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "transformation-of-graphs-using-matrices",
      "keywords": [
        "transformation",
        "matrices",
        "translation",
        "graphs",
        "geometry"
      ],
      "name": "Transformation of Graphs Using Matrices - <a href=\"transformation-of-graphs-using-matrices-translation\">Translation</a>"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "transformation-of-graphs-using-matrices-dilation",
      "keywords": [
        "transformation",
        "matrices",
        "dilation",
        "geometry",
        "scale factor"
      ],
      "name": "Transformation of Graphs Using Matrices - Dilation"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "transformation-of-graphs-using-matrices-translation",
      "keywords": [
        "transformation",
        "graphs",
        "matrices",
        "translation",
        "coordinate"
      ],
      "name": "Transformation of Graphs Using Matrices - Translation"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "transformations-of-graphs",
      "keywords": [
        "transformations",
        "graphs",
        "translations",
        "rotations",
        "reflections"
      ],
      "name": "Transformations of Graphs"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "translations",
      "keywords": [
        "translations",
        "geometry",
        "coordinate plane",
        "transformations",
        "math"
      ],
      "name": "Translations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "transversal",
      "keywords": [
        "transversal",
        "geometry",
        "angles",
        "parallel lines",
        "corresponding angles"
      ],
      "name": "Transversal"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "trapezoid",
      "keywords": [
        "trapezoid",
        "geometry",
        "area",
        "perimeter",
        "isosceles trapezoid"
      ],
      "name": "Trapezoids: Area and Perimeter"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "traceability-of-graphs",
      "keywords": [
        "traceability",
        "graphs",
        "Euler",
        "degree",
        "vertices"
      ],
      "name": "Traversable (Euler-Trail) Graphs"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "triangle-angle-bisector-theorem",
      "keywords": [
        "triangle",
        "angle bisector",
        "geometry",
        "proportional",
        "theorem"
      ],
      "name": "Triangle Angle Bisector Theorem"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "triangle-inequality-theorem",
      "keywords": [
        "triangle",
        "inequality",
        "theorem",
        "geometry",
        "triangles"
      ],
      "name": "Triangle Inequality Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "triangle-midsegment-theorem",
      "keywords": [
        "triangle",
        "midsegment",
        "geometry",
        "theorem",
        "parallel"
      ],
      "name": "Triangle Midsegment Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "triangle-proportionality-theorem",
      "keywords": [
        "triangle",
        "proportionality",
        "theorem",
        "geometry",
        "math"
      ],
      "name": "Triangle Proportionality Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "area-of-triangle",
      "keywords": [
        "area",
        "triangles",
        "geometry",
        "math",
        "formulas"
      ],
      "name": "Triangles: Area"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Triangle",
      "id": "triangles",
      "keywords": [
        "triangles",
        "classification",
        "geometry",
        "angles",
        "sides"
      ],
      "name": "Triangles: Classification"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "trigonometric-functions",
      "keywords": [
        "trigonometry",
        "functions",
        "sine",
        "cosine",
        "tangent"
      ],
      "name": "Trigonometric Functions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "trigonometric-identities",
      "keywords": [
        "trigonometry",
        "identities",
        "Pythagorean",
        "reciprocal",
        "co-function"
      ],
      "name": "Trigonometric Identities"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "trigonometric-ratios",
      "keywords": [
        "trigonometry",
        "ratios",
        "sine",
        "cosine",
        "tangent"
      ],
      "name": "Trigonometric Ratios"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "trigonometric-values-for-common-angles",
      "keywords": [
        "trigonometry",
        "sine",
        "cosine",
        "tangent",
        "angles"
      ],
      "name": "Trigonometric Values for Common Angles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Cone",
      "id": "two-dimensional-views-of-three-dimensional-objects",
      "keywords": [
        "geometry",
        "3D objects",
        "2D views",
        "mathematical visualization",
        "spatial reasoning"
      ],
      "name": "Two-Dimensional Views of Three-Dimensional Objects"
    }
  ],
  "U": [
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "prime-factorization",
      "keywords": [
        "prime factorization",
        "fundamental theorem",
        "natural numbers",
        "factor tree",
        "greatest common factor"
      ],
      "name": "Unique Prime Factorization"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "unit-analysis",
      "keywords": [
        "unit analysis",
        "mathematics",
        "conversion",
        "fractions",
        "multiplication"
      ],
      "name": "Unit Analysis"
    },
    {
      "difficulty": "Beginner",
      "iconName": "Calculator",
      "id": "unit-rates",
      "keywords": [
        "unit rates",
        "ratios",
        "division",
        "real-world math",
        "unit conversion"
      ],
      "name": "Unit Rates"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "unit-vector",
      "keywords": [
        "unit vector",
        "magnitude",
        "direction",
        "vector math",
        "geometry"
      ],
      "name": "Unit Vector"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "using-expected-values-to-make-decisions",
      "keywords": [
        "expected values",
        "probability",
        "decision making",
        "game theory",
        "risk assessment"
      ],
      "name": "Using Expected Values to Make Decisions"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Dice6",
      "id": "using-probabilities-to-make-fair-decisions",
      "keywords": [
        "probability",
        "fair decisions",
        "random variable",
        "expected value",
        "math"
      ],
      "name": "Using Probabilities to Make Fair Decisions"
    }
  ],
  "V": [
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "values-of-trigonometric-ratios-for-common-angles",
      "keywords": [
        "trigonometric ratios",
        "angles",
        "sine",
        "cosine",
        "tangent"
      ],
      "name": "Values of Trigonometric Ratios for Common Angles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Tangent",
      "id": "values-of-trigonometric-ratios-for-standard-angles",
      "keywords": [
        "trigonometry",
        "angles",
        "ratios",
        "sine",
        "cosine"
      ],
      "name": "Values of Trigonometric Ratios for Standard Angles"
    },
    {
      "difficulty": "Beginner",
      "iconName": "SquareFunction",
      "id": "variables",
      "keywords": [
        "variables",
        "mathematics",
        "algebra",
        "functions",
        "equations"
      ],
      "name": "Variables"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "variance",
      "keywords": [
        "variance",
        "statistics",
        "data spread",
        "standard deviation",
        "outliers"
      ],
      "name": "Variance"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "variation-of-data",
      "keywords": [
        "variation",
        "data range",
        "quartiles",
        "interquartile range",
        "median"
      ],
      "name": "Variation of Data"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "vectors",
      "keywords": [
        "vectors",
        "magnitude",
        "direction",
        "physics",
        "mathematics"
      ],
      "name": "Vectors"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "venn-diagrams",
      "keywords": [
        "Venn Diagrams",
        "Intersections",
        "Sets",
        "Mathematical Relationships",
        "John Venn"
      ],
      "name": "Venn Diagrams"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "vertical-angles",
      "keywords": [
        "vertical angles",
        "geometry",
        "congruent angles",
        "intersecting lines",
        "angle pairs"
      ],
      "name": "Vertical Angles"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "vertical-angles-theorem",
      "keywords": [
        "vertical angles",
        "congruent angles",
        "geometry",
        "math theorem",
        "supplementary angles"
      ],
      "name": "Vertical Angles Theorem"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "volume",
      "keywords": [
        "volume",
        "3D shapes",
        "geometry",
        "cubic units",
        "mathematics"
      ],
      "name": "Volume"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "volume-of-a-cone",
      "keywords": [
        "volume",
        "cone",
        "geometry",
        "three-dimensional",
        "math"
      ],
      "name": "Volume of a Cone"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "volume-of-a-cylinder",
      "keywords": [
        "volume",
        "cylinder",
        "geometry",
        "math",
        "3D shapes"
      ],
      "name": "Volume of a Cylinder"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "volume-of-a-prism",
      "keywords": [
        "volume",
        "prism",
        "geometry",
        "3D shapes",
        "mathematics"
      ],
      "name": "Volume of a Prism"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Pyramid",
      "id": "volume-of-a-pyramid",
      "keywords": [
        "volume",
        "pyramid",
        "geometry",
        "3D shapes",
        "mathematics"
      ],
      "name": "Volume of a Pyramid"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "volume-of-a-sphere",
      "keywords": [
        "volume",
        "sphere",
        "geometry",
        "formula",
        "3D shapes"
      ],
      "name": "Volume of a Sphere"
    }
  ],
  "W": [
    {
      "difficulty": "Beginner",
      "iconName": "Hash",
      "id": "whole-numbers",
      "keywords": [
        "whole numbers",
        "<a href=\"natural-numbers\">natural numbers</a>",
        "counting numbers",
        "<a href=\"integers\">integers</a>",
        "<a href=\"real-numbers\">real numbers</a>"
      ],
      "name": "Whole Numbers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "word-problems",
      "keywords": [
        "word problems",
        "math expressions",
        "problem solving",
        "algebra",
        "equations"
      ],
      "name": "Word Problems"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "word-problems-involving-decimals",
      "keywords": [
        "decimals",
        "word problems",
        "math",
        "middle school",
        "practice"
      ],
      "name": "Word Problems Involving Decimals"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Hash",
      "id": "word-problems-involving-integers",
      "keywords": [
        "integers",
        "word problems",
        "math exercises",
        "real-world applications",
        "problem solving"
      ],
      "name": "Word Problems Involving Integers"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "word-problems-involving-one-step-linear-equations",
      "keywords": [
        "linear equations",
        "word problems",
        "one-step equations",
        "math strategies",
        "problem-solving"
      ],
      "name": "Word Problems Involving One-Step Linear Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "word-problems-involving-percent",
      "keywords": [
        "percent",
        "word problems",
        "algebra",
        "proportion",
        "variables"
      ],
      "name": "Word Problems Involving Percent"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "word-problems-involving-the-distributive-property",
      "keywords": [
        "distributive property",
        "word problems",
        "algebra",
        "math practice",
        "middle school math"
      ],
      "name": "Word Problems Involving the Distributive Property"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "word-problems-involving-the-mean-of-a-data-set",
      "keywords": [
        "mean",
        "average",
        "word problems",
        "data set",
        "math problems"
      ],
      "name": "Word Problems Involving the Mean of a Data Set"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "word-problems-involving-two-step-linear-equations",
      "keywords": [
        "word problems",
        "linear equations",
        "two-step equations",
        "middle school math",
        "problem solving"
      ],
      "name": "Word Problems Involving Two-Step Linear Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "word-problems-involving-width-length-and-area",
      "keywords": [
        "geometry",
        "area",
        "width",
        "length",
        "word problems"
      ],
      "name": "Word Problems Involving Width, Length and Area"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Cylinder",
      "id": "word-problems-area-and-perimeter-of-a-rectangle",
      "keywords": [
        "area",
        "perimeter",
        "rectangle",
        "geometry",
        "word problems"
      ],
      "name": "Word Problems: Area and Perimeter of a Rectangle"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "word-problems-equivalent-expressions",
      "keywords": [
        "equivalent expressions",
        "algebraic expressions",
        "word problems",
        "mathematical operations",
        "factorization"
      ],
      "name": "Word Problems: Equivalent Expressions"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Dice6",
      "id": "word-problems-expected-value",
      "keywords": [
        "expected value",
        "probability",
        "word problems",
        "investment",
        "forecast"
      ],
      "name": "Word Problems: Expected Value"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "PieChart",
      "id": "word-problems-inverse-variation",
      "keywords": [
        "inverse variation",
        "word problems",
        "proportional relationships",
        "math problems",
        "middle school math"
      ],
      "name": "Word Problems: Inverse Variation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "word-problems-linear-models",
      "keywords": [
        "linear models",
        "word problems",
        "slope-intercept",
        "point-slope",
        "real-life applications"
      ],
      "name": "Word Problems: Linear Models"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "CircleDot",
      "id": "word-problems-plotting-points",
      "keywords": [
        "Cartesian plane",
        "plotting points",
        "coordinates",
        "word problems",
        "distance"
      ],
      "name": "Word Problems: Plotting Points"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "SquareFunction",
      "id": "word-problems-quadratic-equations",
      "keywords": [
        "quadratic equations",
        "word problems",
        "Pythagorean theorem",
        "equations",
        "math problems"
      ],
      "name": "Word Problems: Quadratic Equations"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Calculator",
      "id": "word-problems-ratios",
      "keywords": [
        "ratios",
        "word problems",
        "math",
        "problem solving",
        "real-world applications"
      ],
      "name": "Word Problems: Ratios"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "word-problems-work-and-workers",
      "keywords": [
        "work problems",
        "shared work",
        "rate of work",
        "math problems",
        "linear equations"
      ],
      "name": "Word Problems: Work and Workers"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Hash",
      "id": "writing-number-patterns-in-function-notation",
      "keywords": [
        "function notation",
        "number patterns",
        "arithmetic sequence",
        "math functions",
        "math patterns"
      ],
      "name": "Writing Number Patterns in Function Notation"
    },
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "writing-systems-of-linear-equations-from-word-problems",
      "keywords": [
        "linear equations",
        "systems",
        "word problems",
        "algebra",
        "variables"
      ],
      "name": "Writing Systems of Linear Equations from Word Problems"
    }
  ],
  "X": [
    {
      "difficulty": "Intermediate",
      "iconName": "BarChart",
      "id": "x-intercepts",
      "keywords": [
        "x-intercepts",
        "functions",
        "graphs",
        "coordinates",
        "mathematics"
      ],
      "name": "x-Intercepts"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Radical",
      "id": "x-intercepts-of-a-quadratic-function",
      "keywords": [
        "quadratic",
        "x-intercepts",
        "discriminant",
        "roots",
        "quadratic formula"
      ],
      "name": "x-intercepts of a Quadratic Function"
    }
  ],
  "Y": [
    {
      "difficulty": "Intermediate",
      "iconName": "TrendingUp",
      "id": "y-intercepts",
      "keywords": [
        "y-intercept",
        "<a href=\"slope-intercept-form\">slope-intercept form</a>",
        "linear equations",
        "graphing",
        "<a href=\"graphing-quadratic-equations\">quadratic equations</a>"
      ],
      "name": "y-Intercepts"
    },
    {
      "difficulty": "Advanced",
      "iconName": "BarChart",
      "id": "y-intercepts-a2-level",
      "keywords": [
        "y-intercepts",
        "functions",
        "graphs",
        "algebra",
        "mathematics"
      ],
      "name": "y-Intercepts a2 level"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Triangle",
      "id": "yang-huis-triangle",
      "keywords": [
        "Yang Hui",
        "Pascal",
        "Triangle",
        "Binomial",
        "Mathematics"
      ],
      "name": "Yang Hui's (Pascal's) Triangle"
    }
  ],
  "Z": [
    {
      "difficulty": "Intermediate",
      "iconName": "Variable",
      "id": "zero-exponents",
      "keywords": [
        "zero exponents",
        "exponents",
        "math",
        "powers",
        "algebra"
      ],
      "name": "Zero Exponents"
    },
    {
      "difficulty": "Advanced",
      "iconName": "Calculator",
      "id": "zero-power-zero",
      "keywords": [
        "zero",
        "power",
        "exponent",
        "undefined",
        "math"
      ],
      "name": "Zero to the Power of Zero"
    }
  ]
};

/**
 * Get all concepts as a flat array
 */
export function getAllConcepts(): ConceptMetadata[] {
  return Object.values(conceptsByLetter).flat();
}

/**
 * Get concepts by difficulty level
 */
export function getConceptsByDifficulty(difficulty: ConceptMetadata['difficulty']): ConceptMetadata[] {
  return getAllConcepts().filter(concept => concept.difficulty === difficulty);
}

/**
 * Search concepts by name or difficulty
 */
export function searchConcepts(query: string): ConceptMetadata[] {
  const searchTerm = query.toLowerCase();
  return getAllConcepts().filter(concept =>
    concept.name.toLowerCase().includes(searchTerm) ||
    concept.difficulty.toLowerCase().includes(searchTerm) ||
    concept.keywords.some(keyword => keyword.toLowerCase().includes(searchTerm))
  );
}

/**
 * Get concept count statistics
 */
export function getConceptStats() {
  const all = getAllConcepts();
  return {
    advanced: all.filter(c => c.difficulty === 'Advanced').length,
    beginner: all.filter(c => c.difficulty === 'Beginner').length,
    byLetter: Object.keys(conceptsByLetter).reduce((stats, letter) => {
      stats[letter] = conceptsByLetter[letter].length;
      return stats;
    }, {} as Record<string, number>),
    intermediate: all.filter(c => c.difficulty === 'Intermediate').length,
    total: all.length,
  };
}
